// AUTO-GENERATED by scripts/generate-customization-asset-maps.js — do not edit by hand.
// Regenerate: npm run generate:asset-maps
// Source: public/assets (1135 customization icons)
// Cache key: 9d3dbadaef75

export const CUSTOMIZATION_ASSETS_CACHE_VERSION = '9d3dbadaef75';

export const MENS_TSHIRT_ASSET_MAP = {
  neckline: {
    'Crew Neck': '/assets/Mens-tshirt/Neck/Crew Neck.png?v=1779801102',
    'Henley Collar': '/assets/Mens-tshirt/Neck/Henley Collar.png?v=1779801102',
    'Polo Collar': '/assets/Mens-tshirt/Neck/Polo Collar.png?v=1779801102',
    'Scoop Neck': '/assets/Mens-tshirt/Neck/Scoop Neck.png?v=1779801102',
    'Turtle Neck': '/assets/Mens-tshirt/Neck/Turtle Neck.png?v=1779801102',
    'V Neck': '/assets/Mens-tshirt/Neck/V Neck.png?v=1779801102',
  },
  sleeve: {
    'Cap Sleeve': '/assets/Mens-tshirt/Sleevees/Cap Sleeve.png?v=1779801102',
    'Long Sleeve': '/assets/Mens-tshirt/Sleevees/Long Sleeve.png?v=1779801102',
    'Raglan Yoke Sleeve': '/assets/Mens-tshirt/Sleevees/Raglan Yoke Sleeve.png?v=1779801102',
    Raglan: '/assets/Mens-tshirt/Sleevees/Raglan.png?v=1779801102',
    'Regular Half': '/assets/Mens-tshirt/Sleevees/Regular Half.png?v=1779801102',
    Ringer: '/assets/Mens-tshirt/Sleevees/Ringer.png?v=1779801102',
    'Sleeveless or Tank': '/assets/Mens-tshirt/Sleevees/Sleeveless or Tank.png?v=1779801102',
  },
};

export const MENS_KURTA_ASSET_MAP = {
  neck: {
    'Asymmetric neck': '/assets/Men kurta/neck/Asymmetric neck.jpg?v=1779801102',
    'Band collar': '/assets/Men kurta/neck/Band collar_.jpg?v=1779801102',
    'Boat neck': '/assets/Men kurta/neck/Boat neck.jpg?v=1779801102',
    'Chinese collar': '/assets/Men kurta/neck/Chinese collar.jpg?v=1779801102',
    'Collar less placket': '/assets/Men kurta/neck/Collar less placket.jpg?v=1779801102',
    'Collar placket': '/assets/Men kurta/neck/Collar placket.jpg?v=1779801102',
    'Keyhole neck': '/assets/Men kurta/neck/Keyhole neck.jpg?v=1779801102',
    'Notch neck': '/assets/Men kurta/neck/Notch neck.jpg?v=1779801102',
    'Round neck': '/assets/Men kurta/neck/Round neck.jpg?v=1779801102',
    'V neck': '/assets/Men kurta/neck/V neck.jpg?v=1779801102',
  },
  sleeve: {
    'Angrakha style sleeve': '/assets/Men kurta/Sleevees/Angrakha style_.jpg?v=1779801102',
    'Button tab sleeve': '/assets/Men kurta/Sleevees/Button tab sleeve_.jpg?v=1779801102',
    'Convertible sleeve': '/assets/Men kurta/Sleevees/Convertible sleeve.jpg?v=1779801102',
    'Cuffed sleeve': '/assets/Men kurta/Sleevees/Cuffed sleeve_.jpg?v=1779801102',
    'Elbow patch': '/assets/Men kurta/Sleevees/Elbow patch_.jpg?v=1779801102',
    'Full sleeve': '/assets/Men kurta/Sleevees/Full sleeve.jpg?v=1779801102',
    'Gusset sleeve': '/assets/Men kurta/Sleevees/Gusset sleeve_.jpg?v=1779801102',
    'Half sleeve': '/assets/Men kurta/Sleevees/Half sleeve_.jpg?v=1779801102',
    'Piped sleeve': '/assets/Men kurta/Sleevees/Piped sleeve_.jpg?v=1779801102',
    'Rolled up sleeve': '/assets/Men kurta/Sleevees/Rolled up sleeve.jpg?v=1779801102',
    'Slit cut sleeve': '/assets/Men kurta/Sleevees/Slit cut sleeve_.jpg?v=1779801102',
    'Three quarter sleeve': '/assets/Men kurta/Sleevees/Three quarter sleeve_.jpg?v=1779801102',
  },
  frontPanel: {
    'Angrakha style': '/assets/Men kurta/front panel/Angrakha style_.jpg?v=1779801102',
    'Asymmetric style': '/assets/Men kurta/front panel/Asymmetric style_.jpg?v=1779801102',
    'Classic straight': '/assets/Men kurta/front panel/Classic straight_.jpg?v=1779801102',
    'Contrast side panel': '/assets/Men kurta/front panel/Contrast side panel.jpg?v=1779801102',
    'Flaired style': '/assets/Men kurta/front panel/Flaired style_.jpg?v=1779801102',
    'Side gusset style': '/assets/Men kurta/front panel/Side gusset style_.jpg?v=1779801102',
    'Slim fit': '/assets/Men kurta/front panel/Slim fit_.jpg?v=1779801102',
  },
};

export const MENS_DHOTI_ASSET_MAP = {
  style: {
    Bengali: '/assets/Dhoti/Bengali dhoti_.jpg?v=1779801102',
    Casual: '/assets/Dhoti/Casual dhoti_.jpg?v=1779801102',
    Classic: '/assets/Dhoti/Classic Dhoti_.jpg?v=1779801102',
    Gujarati: '/assets/Dhoti/Gujarati dhoti_.jpg?v=1779801102',
    Karnataka: '/assets/Dhoti/Karnataka dhoti_.jpg?v=1779801102',
    Kerala: '/assets/Dhoti/Kerala dhoti_.jpg?v=1779801102',
    Maharashtrian: '/assets/Dhoti/Maharashtrian dhoti_.jpg?v=1779801102',
    'Panch Kacha': '/assets/Dhoti/Panch Kacha Dhoti.jpg?v=1779801102',
    'South Indian': '/assets/Dhoti/South Indiandhoti_.jpg?v=1779801102',
  },
};

export const MENS_PAJAMA_ASSET_MAP = {
  style: {
    Aligarh: '/assets/Pajama/Aligarh  pajama.jpg?v=1779801102',
    'Ankle length': '/assets/Pajama/Ankle length pajama_.jpg?v=1779801102',
    Churidar: '/assets/Pajama/Churidar_.jpg?v=1779801102',
    Cigarette: '/assets/Pajama/Cigarette pajama_.jpg?v=1779801102',
    Drawstring: '/assets/Pajama/Drawstring pajama_.jpg?v=1779801102',
    Pathani: '/assets/Pajama/Pathani pajama.jpg?v=1779801102',
    Salwar: '/assets/Pajama/Salwar pajama_.jpg?v=1779801102',
    Straight: '/assets/Pajama/Straight pajama_.jpg?v=1779801102',
    Tapered: '/assets/Pajama/Tapered pajama_.jpg?v=1779801102',
  },
};

export const MENS_CORDSET_ASSET_MAP = {
  style: {
    'Cuban Collar Shirt + Shorts': '/assets/mens cordset/Cuban Collar Shirt + Shorts.png?v=1780209450',
    'Hoodie + Shorts': '/assets/mens cordset/Hoodie + Shorts.png?v=1780209450',
    'Kurta + Churidar': '/assets/mens cordset/Kurta + Churidar.png?v=1780209450',
    'Kurta + Dhoti Pants': '/assets/mens cordset/Kurta + Dhoti Pants.png?v=1780209450',
    'Pathani Kurta + Salwar': '/assets/mens cordset/Pathani Kurta + Salwar.png?v=1780209450',
    'Polo T-Shirt + 3_4 Pants': '/assets/mens cordset/Polo T-Shirt + 3_4 Pants.png?v=1780209450',
    'Polo T-Shirt + Linen (2)': '/assets/mens cordset/Polo T-Shirt + Linen (2).png?v=1780209450',
    'Polo T-Shirt + Linen': '/assets/mens cordset/Polo T-Shirt + Linen.png?v=1780209450',
    'Polo T-Shirt + Tailored Shorts': '/assets/mens cordset/Polo T-Shirt + Tailored Shorts.png?v=1780209450',
    'Shirt + 3_4 Pants': '/assets/mens cordset/Shirt + 3_4 Pants.png?v=1780209450',
    'Shirt + Long Trousers': '/assets/mens cordset/Shirt + Long Trousers.png?v=1780209450',
    'Sleeveless Tee + Shorts': '/assets/mens cordset/Sleeveless Tee + Shorts.png?v=1780209450',
    'T-Shirt + 3_4 Pants': '/assets/mens cordset/T-Shirt + 3_4 Pants.png?v=1780209450',
    'T-Shirt + Long Trousers': '/assets/mens cordset/T-Shirt + Long Trousers.png?v=1780209450',
    'T-Shirt + Shorts': '/assets/mens cordset/T-Shirt + Shorts.png?v=1780209450',
  },
};

export const MENS_PANTS_ASSET_MAP = {
  waist: {
    'Belt loop waist': '/assets/Men pants/Waist area/Belt loop waist_.jpg?v=1779801102',
    'Draw string wast': '/assets/Men pants/Waist area/Draw string wast_.jpg?v=1779801102',
    'Extended waist': '/assets/Men pants/Waist area/Extended waist_.jpg?v=1779801102',
    'Full elastic waist': '/assets/Men pants/Waist area/Full elastic waist_.jpg?v=1779801102',
    'Half elastic waist': '/assets/Men pants/Waist area/Half elastic waist_.jpg?v=1779801102',
    'No waistband': '/assets/Men pants/Waist area/No waistband_.jpg?v=1779801102',
    'Normal waist': '/assets/Men pants/Waist area/Normal waist_.jpg?v=1779801102',
    'Paper bag waist': '/assets/Men pants/Waist area/Paper bag waist_.jpg?v=1779801102',
    'Side adjuster': '/assets/Men pants/Waist area/Side adjuster_.jpg?v=1779801102',
    'Tab waist': '/assets/Men pants/Waist area/Tab waist_.jpg?v=1779801102',
  },
  front: {
    'Button fly': '/assets/Men pants/Front construction/Button fly_.jpg?v=1779801102',
    'Cargo pocket front': '/assets/Men pants/Front construction/Cargo pocket front.jpg?v=1779801102',
    'Concealed hook & Bar closure': '/assets/Men pants/Front construction/Concealed hook & Bar closure_.jpg?v=1779801102',
    'Double button closure': '/assets/Men pants/Front construction/Double button closure_.jpg?v=1779801102',
    'Double pleated': '/assets/Men pants/Front construction/Double pleated_.jpg?v=1779801102',
    'Front dart': '/assets/Men pants/Front construction/Front dart_.jpg?v=1779801102',
    'Patch pocket front': '/assets/Men pants/Front construction/Patch pocket front_.jpg?v=1779801102',
    'Plain front': '/assets/Men pants/Front construction/Plain front.jpg?v=1779801102',
    'Pleated front': '/assets/Men pants/Front construction/Pleated front_.jpg?v=1779801102',
    'Zip fly with top button closure': '/assets/Men pants/Front construction/Zip fly with top button closure.jpg?v=1779801102',
  },
  legStructure: {
    'Baggy leg': '/assets/Men pants/Leg structure variation /Baggy leg_.jpg?v=1779801102',
    'Boot fit': '/assets/Men pants/Leg structure variation /Boot fit_.jpg?v=1779801102',
    'Flared leg': '/assets/Men pants/Leg structure variation /Flared leg.jpg?v=1779801102',
    'Relaxed leg': '/assets/Men pants/Leg structure variation /Relaxed leg_.jpg?v=1779801102',
    'Slim fit': '/assets/Men pants/Leg structure variation /Slim fit_.jpg?v=1779801102',
    'Straight leg': '/assets/Men pants/Leg structure variation /Straight leg_.jpg?v=1779801102',
    'Wide leg': '/assets/Men pants/Leg structure variation /Wide leg_.jpg?v=1779801102',
  },
  rise: {
    'High rise': '/assets/Men pants/Rise variation /High rise_.jpg?v=1779801102',
    'Low rise': '/assets/Men pants/Rise variation /Low rise_.jpg?v=1779801102',
    'Mid rise': '/assets/Men pants/Rise variation /Mid rise_.jpg?v=1779801102',
  },
  lengthPants: {
    'Extra long': '/assets/Men pants/Length variation /Pants /Extra long_.jpg?v=1779801102',
    'Extra short': '/assets/Men pants/Length variation /Pants /Extra short_.jpg?v=1779801102',
    Long: '/assets/Men pants/Length variation /Pants /Long_.jpg?v=1779801102',
    Regular: '/assets/Men pants/Length variation /Pants /Regular.jpg?v=1779801102',
    Short: '/assets/Men pants/Length variation /Pants /Short_.jpg?v=1779801102',
  },
  lengthShorts: {
    Long: '/assets/Men pants/Length variation /Shorts /Long_.jpg?v=1779801102',
    Regular: '/assets/Men pants/Length variation /Shorts /Regular.jpg?v=1779801102',
    Short: '/assets/Men pants/Length variation /Shorts /Short_.jpg?v=1779801102',
  },
  lengthBoyShort: {
    Long: '/assets/Men pants/Length variation /Boy short /Long_.jpg?v=1779801102',
    Regular: '/assets/Men pants/Length variation /Boy short /Regular_.jpg?v=1779801102',
    Short: '/assets/Men pants/Length variation /Boy short /Short.jpg?v=1779801102',
  },
  pocketFront: {
    'Coin pocket': '/assets/Men pants/Pocket /Front /Coin pocket_.jpg?v=1779801102',
    'Curved pocket': '/assets/Men pants/Pocket /Front /Curved pocket_.jpg?v=1779801102',
    'Patch pocket': '/assets/Men pants/Pocket /Front /Patch pocket_.jpg?v=1779801102',
    'Utility pocket': '/assets/Men pants/Pocket /Front /Utility pocket.jpg?v=1779801102',
    'Welt pocket': '/assets/Men pants/Pocket /Front /Welt pocket_.jpg?v=1779801102',
    'Zip pocket': '/assets/Men pants/Pocket /Front /Zip pocket_.jpg?v=1779801102',
  },
  pocketBack: {
    'Button welt pocket': '/assets/Men pants/Pocket /Back /Button welt  pocket.jpg?v=1779801102',
    'Cargo pocket': '/assets/Men pants/Pocket /Back /Cargo pocket_.jpg?v=1779801102',
    'Carpenter pocket': '/assets/Men pants/Pocket /Back /Carpenter pocket.jpg?v=1779801102',
    'Flap pocket': '/assets/Men pants/Pocket /Back /Flap pocket_.jpg?v=1779801102',
    'Hammer loop and pocket': '/assets/Men pants/Pocket /Back /Hammer loop and pocket_.jpg?v=1779801102',
    'Hidden pocket': '/assets/Men pants/Pocket /Back /Hidden pocket_.jpg?v=1779801102',
    'No pocket': '/assets/Men pants/Pocket /Back /No pocket_.jpg?v=1779801102',
    'Patch pocket': '/assets/Men pants/Pocket /Back /Patch pocket_.jpg?v=1779801102',
    'Phone pocket': '/assets/Men pants/Pocket /Back /Phone pocket_.jpg?v=1779801102',
    'Utility pocket': '/assets/Men pants/Pocket /Back /Utility pocket_.jpg?v=1779801102',
    'Welt pocket': '/assets/Men pants/Pocket /Back /Welt pocket_.jpg?v=1779801102',
    'Yoke pocket': '/assets/Men pants/Pocket /Back /Yoke pocket_.jpg?v=1779801102',
    'Zip pocket': '/assets/Men pants/Pocket /Back /Zip pocket_.jpg?v=1779801102',
  },
};

export const MENS_JACKET_ASSET_MAP = {
  collar: {
    'Asymmetric stand collar': '/assets/Men-Jacket/collar/Asymmetric stand collar.jpg?v=1779801102',
    'Attached hood': '/assets/Men-Jacket/collar/Attached hood_.jpg?v=1779801102',
    'Corduroy collar': '/assets/Men-Jacket/collar/Corduroy collar_.jpg?v=1779801102',
    'Detachable collar': '/assets/Men-Jacket/collar/Detachable collar_.jpg?v=1779801102',
    'Detached hood': '/assets/Men-Jacket/collar/Detached hood_.jpg?v=1779801102',
    'Funnel neck': '/assets/Men-Jacket/collar/Funnel neck_.jpg?v=1779801102',
    'High neck (Gaiter)': '/assets/Men-Jacket/collar/High neck (Gaiter).jpg?v=1779801102',
    'Hood with high neck': '/assets/Men-Jacket/collar/Hood with high neck_.jpg?v=1779801102',
    'Ribbed stand collar': '/assets/Men-Jacket/collar/Ribbed stand collar_.jpg?v=1779801102',
    'Shawl collar': '/assets/Men-Jacket/collar/Shawl collar_.jpg?v=1779801102',
    'Sherpa collar': '/assets/Men-Jacket/collar/Sherpa collar_.jpg?v=1779801102',
    'Shirt collar': '/assets/Men-Jacket/collar/Shirt collar_.jpg?v=1779801102',
    'Spread collar': '/assets/Men-Jacket/collar/Spread collar_.jpg?v=1779801102',
    'Stand collar with snap': '/assets/Men-Jacket/collar/Stand collar with snap.jpg?v=1779801102',
    'Stand collar': '/assets/Men-Jacket/collar/Stand collar_.jpg?v=1779801102',
  },
  sleeve: {
    'Adjustable cuff sleeve': '/assets/Men-Jacket/Sleeve option /Adjustable cuff sleeve_.jpg?v=1779801102',
    'Cuffed sleeve': '/assets/Men-Jacket/Sleeve option /Cuffed sleeve_.jpg?v=1779801102',
    'Drop shoulder': '/assets/Men-Jacket/Sleeve option /Drop shoulder_.jpg?v=1779801102',
    'Elbow patch sleeve': '/assets/Men-Jacket/Sleeve option /Elbow patch sleeve_.jpg?v=1779801102',
    'Panelled sleeve': '/assets/Men-Jacket/Sleeve option /Panelled sleeve_.jpg?v=1779801102',
    'Princess sleeve': '/assets/Men-Jacket/Sleeve option /Princess sleeve_.jpg?v=1779801102',
    'Quilted sleeve': '/assets/Men-Jacket/Sleeve option /Quilted sleeve_.jpg?v=1779801102',
    'Raglan sleeve': '/assets/Men-Jacket/Sleeve option /Raglan sleeve_.jpg?v=1779801102',
    'Set in sleeve': '/assets/Men-Jacket/Sleeve option /Set in sleeve_.jpg?v=1779801102',
    'Two-piece sleeve': '/assets/Men-Jacket/Sleeve option /Two-piece sleeve_.jpg?v=1779801102',
  },
  outerShell: {
    'Barn jacket': '/assets/Men-Jacket/Outer shell /Barn jacket_.jpg?v=1779801102',
    'Bomber jacket': '/assets/Men-Jacket/Outer shell /Bomber jacket_.jpg?v=1779801102',
    'Pea coat': '/assets/Men-Jacket/Outer shell /Pea coat_.jpg?v=1779801102',
    'Puffer jacket': '/assets/Men-Jacket/Outer shell /Puffer jacket_.jpg?v=1779801102',
    'Rain jacket': '/assets/Men-Jacket/Outer shell /Rain jacket_.jpg?v=1779801102',
    'Safety jacket': '/assets/Men-Jacket/Outer shell /Safety jacket_.jpg?v=1779801102',
    'Soft shell jacket': '/assets/Men-Jacket/Outer shell /Soft shell jacket.jpg?v=1779801102',
    'Sport jacket': '/assets/Men-Jacket/Outer shell /Sport jacket_.jpg?v=1779801102',
    'Teddy jacket': '/assets/Men-Jacket/Outer shell /Teddy jacket_.jpg?v=1779801102',
    'Windbreaker jacket': '/assets/Men-Jacket/Outer shell /Windbreaker jacket_.jpg?v=1779801102',
  },
};

export const MENS_SHIRT_ASSET_MAP = {
  collar: {
    'Band collar': '/assets/Mens Shirt/collars/Band collar (1).png?v=1780568948',
    'Button down collar': '/assets/Mens Shirt/collars/Button down collar.png?v=1780568948',
    'Club (round) collar': '/assets/Mens Shirt/collars/Club(round) collar.png?v=1780568950',
    'Cutway collar': '/assets/Mens Shirt/collars/Cutway collar.png?v=1780568946',
    'Mandarin collar': '/assets/Mens Shirt/collars/Mandarin collar (1).png?v=1780568948',
    'Spread collar': '/assets/Mens Shirt/collars/Spread collar.png?v=1780568944',
    'Pointed collar': '/assets/Mens Shirt/collars/pointed collar.png?v=1780568946',
  },
  placket: {
    'Concealed hidden placket': '/assets/Mens Shirt/plackets/Concealed_ hidden plackets.png?v=1780568956',
    'French placket': '/assets/Mens Shirt/plackets/French plackets.png?v=1780568954',
    'Half placket': '/assets/Mens Shirt/plackets/Half plackets.png?v=1780568954',
    'Standard placket': '/assets/Mens Shirt/plackets/standard plackets.png?v=1780568956',
  },
  cuff: {
    'Barrel cuff (1 button)': '/assets/Mens Shirt/Cuffs/Barrel cuff (1 Botton).png?v=1780568950',
    'Barrel cuff (2 button)': '/assets/Mens Shirt/Cuffs/Barrel cuff (2 Botton).png?v=1780568950',
    'French cuff': '/assets/Mens Shirt/Cuffs/French cuff.png?v=1780568950',
    'Rounded cuff': '/assets/Mens Shirt/Cuffs/Rounded cuff.png?v=1780568950',
    'Convertible cuff': '/assets/Mens Shirt/Cuffs/convertable cuff.png?v=1780568952',
  },
  sleeve: {
    'Full sleeve': '/assets/Mens Shirt/sleeves/Full sleeve.png?v=1780588758',
    'Half sleeves': '/assets/Mens Shirt/sleeves/Half sleeves.png?v=1780588756',
    'Roll-up sleeve with tab': '/assets/Mens Shirt/sleeves/Roll-up sleeve with tab.png?v=1780588758',
  },
  fit: {
    'Oversized fit': '/assets/Mens Shirt/Fit/Oversized fit.png?v=1780589274',
    'Regular fit': '/assets/Mens Shirt/Fit/Regular fit.png?v=1780589274',
    'Relaxed fit': '/assets/Mens Shirt/Fit/Relaxed fit.png?v=1780589274',
    'Slim fit': '/assets/Mens Shirt/Fit/Slim fit.png?v=1780589276',
    'Tailored fit': '/assets/Mens Shirt/Fit/Tailored  fit.png?v=1780589276',
  },
  hem: {
    'Curved hem': '/assets/Mens Shirt/Hems/Curved hem.png?v=1780589344',
    'High low hem': '/assets/Mens Shirt/Hems/High low hem.png?v=1780589344',
    'Long hem': '/assets/Mens Shirt/Hems/long hem.png?v=1780589344',
    'Straight hem': '/assets/Mens Shirt/Hems/straight hem.png?v=1780589344',
  },
  backPleat: {
    'No pleat (flat)': '/assets/Mens Shirt/back pleats/No pleat (flat).png?v=1780589636',
    'Side pleat': '/assets/Mens Shirt/back pleats/Side pleat.png?v=1780589636',
    'Back darts': '/assets/Mens Shirt/back pleats/back darts.png?v=1780589636',
    'Box pleat': '/assets/Mens Shirt/back pleats/box pleat.png?v=1780589636',
  },
  pocket: {
    'Double pocket': '/assets/Mens Shirt/pockets illustration/Double pocket.png?v=1780588506',
    'Flap pocket': '/assets/Mens Shirt/pockets illustration/Flap pocket.png?v=1780588504',
    'Single pocket': '/assets/Mens Shirt/pockets illustration/Single pocket.png?v=1780588506',
    'Utility pocket': '/assets/Mens Shirt/pockets illustration/Utility pocket.png?v=1780588506',
    'Welt pocket': '/assets/Mens Shirt/pockets illustration/Welt pocket.png?v=1780588506',
  },
};

export const MENS_BLAZER_ASSET_MAP = {
  collar: {
    'Mandarin collar': '/assets/Mens Blazer/collars/Mandarin collar.png?v=1780675134',
    'Shawl collar': '/assets/Mens Blazer/collars/Shawl collar.png?v=1780675134',
    'Standard blazer collar': '/assets/Mens Blazer/collars/Standard blazer collar.png?v=1780675134',
  },
  buttons: {
    'Double breasted': '/assets/Mens Blazer/Bottons/Double breasted.png?v=1780675382',
    'Single button': '/assets/Mens Blazer/Bottons/Single button.png?v=1780675326',
    'Three button': '/assets/Mens Blazer/Bottons/Three button.png?v=1780675326',
    'Two button': '/assets/Mens Blazer/Bottons/Two button.png?v=1780675326',
  },
  vents: {
    'Double vent': '/assets/Mens Blazer/Vents/Double vent.png?v=1780674718',
    'No vent': '/assets/Mens Blazer/Vents/No vent.png?v=1780674718',
    'Single vent': '/assets/Mens Blazer/Vents/Single vent.png?v=1780674718',
  },
  hem: {
    'Rounded front hem': '/assets/Mens Blazer/hems/Rounded front hem.png?v=1780675100',
    'Staright hem': '/assets/Mens Blazer/hems/staright hem.png?v=1780675100',
  },
  pockets: {
    'Chest welt pocket': '/assets/Mens Blazer/pockets/Chest welt pocket.png?v=1780674818',
    'Flap pocket': '/assets/Mens Blazer/pockets/Flap pocket.png?v=1780674818',
    'Patch pocket': '/assets/Mens Blazer/pockets/Patch pocket.png?v=1780674818',
    'Ticket pocket': '/assets/Mens Blazer/pockets/Ticket pocket.png?v=1780674818',
    'Welt pocket': '/assets/Mens Blazer/pockets/Welt pocket.png?v=1780674818',
  },
};

export const MENS_WAISTCOAT_ASSET_MAP = {
  traditional: {
    Angarkha: '/assets/Men Waistcoat/Traditional waistcoat/Aangarkha style waistcoat.png?v=1779801102',
    Asymmetric: '/assets/Men Waistcoat/Traditional waistcoat/Asymetric waistcoat.png?v=1779801102',
    Bandhgala: '/assets/Men Waistcoat/Traditional waistcoat/Bandhgala waistcoat.png?v=1779801102',
    'Double breasted': '/assets/Men Waistcoat/Traditional waistcoat/Double breasted waistcoat.png?v=1779801102',
    'Open front': '/assets/Men Waistcoat/Traditional waistcoat/Open front waistcoat.png?v=1779801102',
    'High-low hem': '/assets/Men Waistcoat/Traditional waistcoat/high low hem waistcoat.png?v=1779801102',
    Layered: '/assets/Men Waistcoat/Traditional waistcoat/layered waistcoat.png?v=1779801102',
    Longline: '/assets/Men Waistcoat/Traditional waistcoat/longline waistcoat.png?v=1779801102',
    Overlap: '/assets/Men Waistcoat/Traditional waistcoat/overlap waistcoat.png?v=1779801102',
    'Single breasted': '/assets/Men Waistcoat/Traditional waistcoat/single breasted waistcoat.png?v=1779801102',
  },
  nehruJacket: {
    Angarkha: '/assets/Men Waistcoat/Nehru jacket/Angrkha nehru jacket.png?v=1779801102',
    Asymmetric: '/assets/Men Waistcoat/Nehru jacket/Asymetric nehru jacket.png?v=1779801102',
    Bandhgala: '/assets/Men Waistcoat/Nehru jacket/bandhgala nehru jacket.png?v=1779801102',
    Long: '/assets/Men Waistcoat/Nehru jacket/long nehru jacket.png?v=1779801102',
    Short: '/assets/Men Waistcoat/Nehru jacket/short nehru jacket.png?v=1779801102',
  },
  westernTuxedo: {
    Safari: '/assets/Men Waistcoat/western tuxedo  /Safari waistcoat.jpg?v=1779801102',
    Steampunk: '/assets/Men Waistcoat/western tuxedo  /Steampunk waistcoat.jpg?v=1779801102',
    Tuxedo: '/assets/Men Waistcoat/western tuxedo  /Tuxdo waistcote.jpg?v=1779801102',
    'U neck': '/assets/Men Waistcoat/western tuxedo  /U neck waistcoat.jpg?v=1779801102',
    'V neck': '/assets/Men Waistcoat/western tuxedo  /V neck waist coat.jpg?v=1779801102',
    Victorian: '/assets/Men Waistcoat/western tuxedo  /Vectorian waistcoat.jpg?v=1779801102',
    'Double busted': '/assets/Men Waistcoat/western tuxedo  /double busted waist coat.jpg?v=1779801102',
    'Single busted': '/assets/Men Waistcoat/western tuxedo  /single busted waist coat.jpg?v=1779801102',
    Cowboy: '/assets/Men Waistcoat/western tuxedo  /western cowboy waistcoat.jpg?v=1779801102',
  },
};

export const KIDS_BOY_TODDLER_ASSET_MAP = {
  style: {
    'Basic short sleeve one size': '/assets/toddler/style/Basic short sleeve  one size_.jpg?v=1779801102',
    'Bib overall romper': '/assets/toddler/style/Bib overall romper_.jpg?v=1779801102',
    'Envelope neck': '/assets/toddler/style/Envelope neck_.jpg?v=1779801102',
    'Front open romper': '/assets/toddler/style/Front open romper_.jpg?v=1779801102',
    'Henley onesie': '/assets/toddler/style/Henley onesie_.jpg?v=1779801102',
    'Kimono wrap romper': '/assets/toddler/style/Kimono wrap romper .JPG?v=1779801102',
    'Long sleeve footed romper': '/assets/toddler/style/Long sleeve footed romper_.jpg?v=1779801102',
    'Polo collar onesie': '/assets/toddler/style/Polo collar onesie .JPG?v=1779801102',
    'Sleeveless romper with pocket': '/assets/toddler/style/Sleeveless romper with pocket_.jpg?v=1779801102',
    'Tank style Henley romper': '/assets/toddler/style/Tank style Henley romper .JPG?v=1779801102',
  },
};

export const WOMEN_TOP_ASSET_MAP = {
  neckline: {
    'Cowl Neck': '/assets/Top/neckline/Cowl Neck.png?v=1780808004',
    'Crew neck': '/assets/Top/neckline/Crew neck.png?v=1780808004',
    'Deep V neck': '/assets/Top/neckline/Deep V neck.png?v=1780808004',
    'Draped Neck': '/assets/Top/neckline/Draped Neck.png?v=1780808004',
    'Haltar Neck': '/assets/Top/neckline/Haltar Neck.png?v=1780808004',
    'High Neck': '/assets/Top/neckline/High Neck.png?v=1780808004',
    'Jewel neck': '/assets/Top/neckline/Jewel neck.png?v=1780808004',
    'Keyhole Neck': '/assets/Top/neckline/Keyhole Neck.png?v=1780808004',
    'Mandarin Neck': '/assets/Top/neckline/Mandarin Neck.png?v=1780808004',
    'Notched Neck': '/assets/Top/neckline/Notched Neck.png?v=1780808004',
    'Queen anne Neck': '/assets/Top/neckline/Queen anne  Neck.png?v=1780808006',
    'Rectangle Neck': '/assets/Top/neckline/Rectangle Neck.png?v=1780808006',
    'Round neck': '/assets/Top/neckline/Round neck.png?v=1780808006',
    'Sabrina neck': '/assets/Top/neckline/Sabrina neck.png?v=1780808006',
    'Scalloped Neck': '/assets/Top/neckline/Scalloped Neck.png?v=1780808006',
    'Scoop neck': '/assets/Top/neckline/Scoop neck.png?v=1780808008',
    'Square Neck': '/assets/Top/neckline/Square Neck.png?v=1780808006',
    'Surplice neck': '/assets/Top/neckline/Surplice neck.png?v=1780808008',
    'Sweetheart neck': '/assets/Top/neckline/Sweetheart neck.png?v=1780808008',
    'V neck': '/assets/Top/neckline/V neck.png?v=1780808008',
    'Bardot Neck': '/assets/Top/neckline/bardot Neck.png?v=1780808002',
    'Cold shoulder Neck': '/assets/Top/neckline/cold shoulder Neck.png?v=1780808004',
    'Illusion Neck': '/assets/Top/neckline/illusion Neck.png?v=1780808004',
    'Off-shoulder Neck': '/assets/Top/neckline/off - shoulder Neck.png?v=1780808004',
    'One shoulder Neck': '/assets/Top/neckline/one shoulder Neck.png?v=1780808004',
    'Plunging neck': '/assets/Top/neckline/plunging neck.png?v=1780808004',
    'Portrait neck': '/assets/Top/neckline/portrait neck.png?v=1780808006',
    'Turtle Neck': '/assets/Top/neckline/turle Neck.png?v=1780808008',
  },
  sleeve: {
    'Angle sleeves': '/assets/Top/Sleeves/Angle sleeves.png?v=1780807868',
    'Batwing sleeve': '/assets/Top/Sleeves/Batwing sleeve.png?v=1780807868',
    'Bell sleeves': '/assets/Top/Sleeves/Bell sleeves.png?v=1780807868',
    'Butterfly sleeves': '/assets/Top/Sleeves/Butterfly sleeves.png?v=1780807868',
    'Cap Sleeves': '/assets/Top/Sleeves/Cap Sleeves.png?v=1780807868',
    'Dolman sleeve': '/assets/Top/Sleeves/Dolman sleeve.png?v=1780807868',
    'Flared peplum sleeves': '/assets/Top/Sleeves/Flared peplum sleeves.png?v=1780807868',
    'Flounce sleeves': '/assets/Top/Sleeves/Flounce sleeves.png?v=1780807868',
    'Flute sleeves': '/assets/Top/Sleeves/Flute sleeves.png?v=1780807868',
    'Flutter sleeves (2)': '/assets/Top/Sleeves/Flutter sleeves (2).png?v=1780807868',
    'Flutter sleeves': '/assets/Top/Sleeves/Flutter sleeves.png?v=1780807868',
    'Full Sleeves': '/assets/Top/Sleeves/Full Sleeves.png?v=1780807868',
    'Gigot sleeve': '/assets/Top/Sleeves/Gigot sleeve.png?v=1780807868',
    'Half Sleeves': '/assets/Top/Sleeves/Half Sleeves.png?v=1780807868',
    'Kimono sleeve': '/assets/Top/Sleeves/Kimono sleeve.png?v=1780807870',
    'Leg-o-mutton sleeves': '/assets/Top/Sleeves/Leg-o-mutton sleeves.png?v=1780807870',
    'Medieval sleeves': '/assets/Top/Sleeves/Medieval sleeves.png?v=1780807872',
    'Raglan sleeve': '/assets/Top/Sleeves/Raglan sleeve.png?v=1780807872',
    'Ruched sleeves': '/assets/Top/Sleeves/Ruched sleeves.png?v=1780807872',
    'Shirred sleeves': '/assets/Top/Sleeves/Shirred sleeves.png?v=1780807872',
    'Short Sleeves': '/assets/Top/Sleeves/Short Sleeves.png?v=1780807872',
    Sleeveless: '/assets/Top/Sleeves/Sleeveless.png?v=1780807872',
    'Slit sleeves': '/assets/Top/Sleeves/Slit sleeves.png?v=1780807872',
    'Smocked sleeves': '/assets/Top/Sleeves/Smocked sleeves.png?v=1780807872',
    'Three quarter Sleeves': '/assets/Top/Sleeves/Three quarter Sleeves.png?v=1780807872',
    'Tiered sleeves': '/assets/Top/Sleeves/Tiered sleeves.png?v=1780807874',
    'Bishop sleeves': '/assets/Top/Sleeves/bishop sleeves.png?v=1780807868',
    'Cape sleeves': '/assets/Top/Sleeves/cape sleeves.png?v=1780807868',
    'Juliette sleeves': '/assets/Top/Sleeves/juliette sleeves.png?v=1780807870',
    'Lantern sleeves': '/assets/Top/Sleeves/lantern sleeves.png?v=1780807870',
    'Open sleeves': '/assets/Top/Sleeves/open sleeves.png?v=1780807872',
    'Petal sleeves': '/assets/Top/Sleeves/petal sleeves.png?v=1780807872',
    'Poet sleeves': '/assets/Top/Sleeves/poet sleeves.png?v=1780807872',
    'Puff sleeve': '/assets/Top/Sleeves/puff sleeve.png?v=1780807872',
    'Tulip sleeves': '/assets/Top/Sleeves/tulip sleeves.png?v=1780807874',
  },
  hem: {
    'Angled Hem': '/assets/Top/Hems/Angled Hem.png?v=1780808084',
    'Asymmetrical Hem': '/assets/Top/Hems/Asymmetrical Hem.png?v=1780808086',
    'Back Slit Hem': '/assets/Top/Hems/Back Slit Hem.png?v=1780808086',
    'Balloon Hem': '/assets/Top/Hems/Balloon Hem.png?v=1780808086',
    'Blind Hem': '/assets/Top/Hems/Blind Hem.png?v=1780808086',
    'Bound Hem': '/assets/Top/Hems/Bound Hem.png?v=1780808086',
    'Boxy Hem': '/assets/Top/Hems/Boxy Hem.png?v=1780808086',
    'Bubble Hem': '/assets/Top/Hems/Bubble Hem.png?v=1780808086',
    'Cascade Hem': '/assets/Top/Hems/Cascade Hem.png?v=1780808086',
    'Crop Hem': '/assets/Top/Hems/Crop Hem.png?v=1780808086',
    'Curved Hem': '/assets/Top/Hems/Curved  Hem.png?v=1780808086',
    'Diagonal Hem': '/assets/Top/Hems/Diagonal Hem.png?v=1780808086',
    'Double Side Slit Hem': '/assets/Top/Hems/Double Side Slit Hem.png?v=1780808086',
    'Draped Hem': '/assets/Top/Hems/Draped Hem.png?v=1780808086',
    'Faced Hem': '/assets/Top/Hems/Faced Hem.png?v=1780808086',
    'Flounce Hem': '/assets/Top/Hems/Flounce Hem.png?v=1780808086',
    'Frayed Hem': '/assets/Top/Hems/Frayed Hem.png?v=1780808088',
    'Front Slit Hem': '/assets/Top/Hems/Front Slit Hem.png?v=1780808088',
    'Handkerchief Hem': '/assets/Top/Hems/Handkerchief Hem.png?v=1780808088',
    'High-Low Hem (2)': '/assets/Top/Hems/High-Low Hem (2).png?v=1780808088',
    'High-Low Hem': '/assets/Top/Hems/High-Low Hem.png?v=1780808088',
    'Knot Hem': '/assets/Top/Hems/Knot Hem.png?v=1780808088',
    'Layered Hem': '/assets/Top/Hems/Layered Hem.png?v=1780808088',
    'Overlap Hem': '/assets/Top/Hems/Overlap Hem.png?v=1780808088',
    'Peplum Hem': '/assets/Top/Hems/Peplum Hem.png?v=1780808088',
    'Piped Hem': '/assets/Top/Hems/Piped Hem.png?v=1780808088',
    'Pointed Hem': '/assets/Top/Hems/Pointed Hem.png?v=1780808088',
    'Raw Hem': '/assets/Top/Hems/Raw Hem.png?v=1780808088',
    'Rolled Hem': '/assets/Top/Hems/Rolled Hem.png?v=1780808090',
    'Rounded Hem': '/assets/Top/Hems/Rounded  Hem.png?v=1780808088',
    'Ruffle Hem': '/assets/Top/Hems/Ruffle Hem.png?v=1780808090',
    'Scalloped Hem': '/assets/Top/Hems/Scalloped Hem.png?v=1780808090',
    'Shirt Tail Hem': '/assets/Top/Hems/Shirt Tail  Hem.png?v=1780808090',
    'Side Slit Hem': '/assets/Top/Hems/Side Slit Hem.png?v=1780808090',
    'Straight Hem': '/assets/Top/Hems/Straight Hem.png?v=1780808090',
    'Tiered Hem': '/assets/Top/Hems/Tiered Hem.png?v=1780808090',
    'Tulip Hem': '/assets/Top/Hems/Tulip Hem.png?v=1780808090',
    'Turned-Up Hem': '/assets/Top/Hems/Turned-Up Hem.png?v=1780808092',
    'Twist Hem': '/assets/Top/Hems/Twist Hem.png?v=1780808092',
    'U-Shaped Hem': '/assets/Top/Hems/U-Shaped  Hem.png?v=1780808092',
    'Wrap Hem': '/assets/Top/Hems/Wrap Hem.png?v=1780808092',
  },
  yoke: {
    'Angular yoke': '/assets/Top/Yoke/Angular yoke.png?v=1780807488',
    'Asymetrical yoke': '/assets/Top/Yoke/Asymetrical yoke.png?v=1780807488',
    'Curved yoke': '/assets/Top/Yoke/Curved yoke.png?v=1780807486',
    'Diamond yoke': '/assets/Top/Yoke/Diamond yoke.png?v=1780807486',
    'Empire yoke': '/assets/Top/Yoke/Empire yoke.png?v=1780807488',
    'Gathered yoke': '/assets/Top/Yoke/Gathered yoke.png?v=1780807488',
    'Layered yoke': '/assets/Top/Yoke/Layered yoke.png?v=1780807486',
    'Round yoke': '/assets/Top/Yoke/Round yoke.png?v=1780807488',
    'Scalloped yoke': '/assets/Top/Yoke/Scalloped yoke.png?v=1780807490',
    'Square yoke': '/assets/Top/Yoke/Square yoke.png?v=1780807490',
    'Straight yoke': '/assets/Top/Yoke/Straight yoke.png?v=1780807490',
    'Sweetheart yoke': '/assets/Top/Yoke/Sweetheart yoke.png?v=1780807490',
    'U shaped yoke': '/assets/Top/Yoke/U shaped yoke.png?v=1780807490',
    'V shaped yoke': '/assets/Top/Yoke/V shaped yoke.png?v=1780807490',
    'Angrkha yoke': '/assets/Top/Yoke/angrkha yoke.png?v=1780807488',
    'Chevron yoke': '/assets/Top/Yoke/chevron yoke.png?v=1780807488',
    'Panel yoke': '/assets/Top/Yoke/panel yoke.png?v=1780807488',
    'Pleated yoke': '/assets/Top/Yoke/pleated yoke.png?v=1780807488',
    'Pointed yoke': '/assets/Top/Yoke/pointed yoke.png?v=1780807488',
    'Potli button yoke': '/assets/Top/Yoke/potli button yoke.png?v=1780807488',
    'Princess yoke': '/assets/Top/Yoke/princess yoke.png?v=1780807488',
    'Round kurti yoke': '/assets/Top/Yoke/round kurti yoke.png?v=1780807488',
    'Smoked yoke': '/assets/Top/Yoke/smoked yoke.png?v=1780807490',
  },
  topLength: {
    'Crop top': '/assets/Top/Top lengths/Crop top.png?v=1780808448',
    'Dress length top': '/assets/Top/Top lengths/Dress Length Top.png?v=1780808448',
    'Hip length': '/assets/Top/Top lengths/Hip Length.png?v=1780808448',
    'Tunic length': '/assets/Top/Top lengths/Tunic Length.png?v=1780808448',
    'Waist length': '/assets/Top/Top lengths/Waist Length.png?v=1780808448',
  },
  bodice: {
    'Accordion Pleated': '/assets/Top/Bodices/Accordion Pleated.png?v=1780808210',
    Blouson: '/assets/Top/Bodices/Blouson.png?v=1780808210',
    'Box Pleated': '/assets/Top/Bodices/Box Pleated.png?v=1780808210',
    Boxy: '/assets/Top/Bodices/Boxy.png?v=1780808210',
    Bubble: '/assets/Top/Bodices/Bubble.png?v=1780808212',
    'Bustier Shape': '/assets/Top/Bodices/Bustier Shape.png?v=1780808210',
    'Cape Top': '/assets/Top/Bodices/Cape Top.png?v=1780808210',
    'Cinched Waist': '/assets/Top/Bodices/Cinched Waist.png?v=1780808212',
    'Corset Top': '/assets/Top/Bodices/Corset Top.png?v=1780808212',
    'Couture structured corset': '/assets/Top/Bodices/Couture Structured Corset.png?v=1780659958',
    'Crystal Pleated': '/assets/Top/Bodices/Crystal Pleated.png?v=1780808212',
    Draped: '/assets/Top/Bodices/Draped.png?v=1780808210',
    'Drawstring ruched': '/assets/Top/Bodices/Drawstring ruched.png?v=1780808212',
    Flared: '/assets/Top/Bodices/Flared.png?v=1780808212',
    Gathered: '/assets/Top/Bodices/Gathered.png?v=1780808214',
    'Godet Flare': '/assets/Top/Bodices/Godet Flare.png?v=1780808214',
    'Inverted Pleated': '/assets/Top/Bodices/Inverted Pleated.png?v=1780808214',
    'Kaftan Shape': '/assets/Top/Bodices/Kaftan Shape.png?v=1780808214',
    'Kimono Shape': '/assets/Top/Bodices/Kimono Shape.png?v=1780808214',
    'Knife Pleated': '/assets/Top/Bodices/Knife Pleated.png?v=1780808214',
    Pleated: '/assets/Top/Bodices/Pleated.png?v=1780808214',
    'Poncho Top': '/assets/Top/Bodices/Poncho Top.png?v=1780808214',
    Smocked: '/assets/Top/Bodices/Smocked.png?v=1780808214',
    'Structured corset': '/assets/Top/Bodices/Structured corset.png?v=1780659958',
    'Sunray pleated': '/assets/Top/Bodices/Sunray Pleated.png?v=1780808214',
    'Trapeze Shape': '/assets/Top/Bodices/Trapeze Shape.png?v=1780808214',
    'Twist Draped': '/assets/Top/Bodices/Twist Draped.png?v=1780808214',
    'Waterfall Draped': '/assets/Top/Bodices/Waterfall Draped.png?v=1780808214',
    'Wrap Draped': '/assets/Top/Bodices/Wrap Draped.png?v=1780808216',
    'all over ruched': '/assets/Top/Bodices/all over ruched.png?v=1780808210',
    'asymmetric ruched': '/assets/Top/Bodices/asymmetric ruched.png?v=1780808210',
    'center back ruched': '/assets/Top/Bodices/center back ruched.png?v=1780808212',
    'center ruched': '/assets/Top/Bodices/center ruched.png?v=1780808210',
    'Peplum corset': '/assets/Top/Bodices/peplum corset.png?v=1780659958',
    'side ruched': '/assets/Top/Bodices/side ruched.png?v=1780808214',
    'waist ruched': '/assets/Top/Bodices/waist ruched.png?v=1780808214',
  },
  panels: {
    'Angular Panel': '/assets/Top/Panels/Angular Panel.png?v=1780807954',
    'Asymmetrical Panel': '/assets/Top/Panels/Asymmetrical Panel.png?v=1780807954',
    'Basque Panel': '/assets/Top/Panels/Basque Panel.png?v=1780807954',
    'Cascade Panel': '/assets/Top/Panels/Cascade Panel.png?v=1780807954',
    'Center Panel': '/assets/Top/Panels/Center Panel.png?v=1780807954',
    'Contour Panel': '/assets/Top/Panels/Contour Panel.png?v=1780807954',
    'Corset panel': '/assets/Top/Panels/Corset Panel.png?v=1780807954',
    'Draped Panel': '/assets/Top/Panels/Draped Panel.png?v=1780807954',
    'Empire Panel': '/assets/Top/Panels/Empire Panel.png?v=1780807954',
    'Flared Panel': '/assets/Top/Panels/Flared Panel.png?v=1780807954',
    'Gathered Panel': '/assets/Top/Panels/Gathered Panel.png?v=1780807954',
    'Godet Panel': '/assets/Top/Panels/Godet Panel.png?v=1780807954',
    'Layered Panel': '/assets/Top/Panels/Layered Panel.png?v=1780807954',
    'Overlap Panel': '/assets/Top/Panels/Overlap Panel.png?v=1780807954',
    'Peplum Panel': '/assets/Top/Panels/Peplum Panel.png?v=1780807954',
    'Pleated Panel': '/assets/Top/Panels/Pleated Panel.png?v=1780807954',
    'Princess Panel': '/assets/Top/Panels/Princess Panel.png?v=1780807956',
    'Sculpted Panel': '/assets/Top/Panels/Sculpted Panel.png?v=1780807956',
    'Shoulder Panel': '/assets/Top/Panels/Shoulder Panel.png?v=1780807956',
    'Side Panel': '/assets/Top/Panels/Side Panel.png?v=1780807956',
    'Tiered Panel': '/assets/Top/Panels/Tiered Panel.png?v=1780807958',
    'Waist Pane': '/assets/Top/Panels/Waist Pane.png?v=1780807956',
    'Wrap Panel': '/assets/Top/Panels/Wrap Panel.png?v=1780807956',
  },
  pocket: {
    'Angled Patch Pocket': '/assets/Top/Pockets/Angled Patch Pocket.png?v=1780807922',
    'Asymmetrical Pocket': '/assets/Top/Pockets/Asymmetrical Pocket.png?v=1780807922',
    'Bellows Patch Pocket': '/assets/Top/Pockets/Bellows Patch Pocket.png?v=1780807922',
    'Bound Pocket': '/assets/Top/Pockets/Bound Pocket.png?v=1780807922',
    'Button Pocket': '/assets/Top/Pockets/Button Pocket.png?v=1780807922',
    'Cargo Pocket': '/assets/Top/Pockets/Cargo Pocket.png?v=1780807922',
    'Curved Patch Pocket': '/assets/Top/Pockets/Curved Patch Pocket.png?v=1780807922',
    'Double Chest Pocket': '/assets/Top/Pockets/Double Chest Pocket.png?v=1780807922',
    'Double Welt Pockets': '/assets/Top/Pockets/Double Welt Pockets.png?v=1780807922',
    'Drawstring Pocket': '/assets/Top/Pockets/Drawstring Pocket.png?v=1780807922',
    'Flap Patch Pocket': '/assets/Top/Pockets/Flap Patch Pocket.png?v=1780807922',
    'Flap Welt Pocket': '/assets/Top/Pockets/Flap Welt Pocket.png?v=1780807922',
    'Gathered Pocket': '/assets/Top/Pockets/Gathered Pocket.png?v=1780807922',
    'Heart-Shaped Pocket': '/assets/Top/Pockets/Heart-Shaped Pocket.png?v=1780807922',
    'Hidden Seam Pocket': '/assets/Top/Pockets/Hidden Seam Pocket.png?v=1780807922',
    'Layered Pocket': '/assets/Top/Pockets/Layered Pocket.png?v=1780807922',
    'Panel Seam Pocket': '/assets/Top/Pockets/Panel Seam Pocket.png?v=1780807924',
    'Pleated Patch Pocket': '/assets/Top/Pockets/Pleated Patch Pocket.png?v=1780807924',
    'Pleated Pocket': '/assets/Top/Pockets/Pleated Pocket.png?v=1780807924',
    'Princess Seam Pocket': '/assets/Top/Pockets/Princess Seam Pocket.png?v=1780807924',
    'Rounded Patch Pocket': '/assets/Top/Pockets/Rounded Patch Pocket.png?v=1780807926',
    'Ruffle Pocket': '/assets/Top/Pockets/Ruffle Pocket.png?v=1780807926',
    'Scalloped Pocket': '/assets/Top/Pockets/Scalloped Pocket.png?v=1780807926',
    'Side Seam Pocket': '/assets/Top/Pockets/Side Seam Pocket.png?v=1780807926',
    'Single Chest Pocket': '/assets/Top/Pockets/Single Chest Pocket.png?v=1780807926',
    'Snap Pocket': '/assets/Top/Pockets/Snap Pocket.png?v=1780807926',
    'Square Patch Pocket': '/assets/Top/Pockets/Square Patch Pocket.png?v=1780807926',
    'Welt Pockets': '/assets/Top/Pockets/Welt Pockets.png?v=1780807926',
    'Western Chest Pocket': '/assets/Top/Pockets/Western Chest Pocket.png?v=1780807926',
    'Zip Pocket': '/assets/Top/Pockets/Zip Pocket.png?v=1780807926',
  },
  dart: {
    'Neck dart': '/assets/Top/Darts/Neck dart.png?v=1780808140',
    'bust dart': '/assets/Top/Darts/bust dart.png?v=1780808138',
    'princess line dart': '/assets/Top/Darts/princess line dart.png?v=1780808140',
    'waist dart': '/assets/Top/Darts/waist dart.png?v=1780808140',
  },
  strap: {
    'Adjustable Strap': '/assets/Top/straps/Adjustable Strap.png?v=1779738134',
    'Around-Neck Strap': '/assets/Top/straps/Around-Neck Strap.png?v=1779738134',
    'Beaded Strap': '/assets/Top/straps/Beaded Strap.png?v=1779738134',
    'Bow Strap': '/assets/Top/straps/Bow Strap.png?v=1779738134',
    'Braided Strap': '/assets/Top/straps/Braided Strap.png?v=1779738134',
    'Buckle Strap': '/assets/Top/straps/Buckle Strap.png?v=1779738134',
    'Cage Strap': '/assets/Top/straps/Cage Strap.png?v=1779738134',
    'Chain Strap': '/assets/Top/straps/Chain Strap.png?v=1779738134',
    'Corset Strap': '/assets/Top/straps/Corset Strap.png?v=1779738134',
    'Criss-Cross Strap': '/assets/Top/straps/Criss-Cross Strap.png?v=1779738134',
    'Cross Neck Strap': '/assets/Top/straps/Cross Neck Strap.png?v=1779738134',
    'Cut-Out Strap': '/assets/Top/straps/Cut-Out Strap.png?v=1779738134',
    'Double Strap': '/assets/Top/straps/Double Strap.png?v=1779738134',
    'Gathered Strap': '/assets/Top/straps/Gathered Strap.png?v=1779738134',
    'Halter Strap': '/assets/Top/straps/Halter Strap.png?v=1779738134',
    'Harness Strap (2)': '/assets/Top/straps/Harness Strap (2).png?v=1779738134',
    'Harness Strap': '/assets/Top/straps/Harness Strap.png?v=1779738134',
    'Knot Strap': '/assets/Top/straps/Knot Strap.png?v=1779738134',
    'Medium Strap': '/assets/Top/straps/Medium Strap.png?v=1779738134',
    'Multi Strap': '/assets/Top/straps/Multi Strap.png?v=1779738134',
    'Neck Tie Strap': '/assets/Top/straps/Neck Tie Strap.png?v=1779738134',
    'Off-Shoulder Strap': '/assets/Top/straps/Off-Shoulder Strap.png?v=1779738134',
    'One-Shoulder Strap': '/assets/Top/straps/One-Shoulder Strap.png?v=1779738134',
    'Racerback Strap': '/assets/Top/straps/Racerback Strap.png?v=1779738134',
    'Ruffle Strap': '/assets/Top/straps/Ruffle Strap.png?v=1779738134',
    'Straight Shoulder Strap': '/assets/Top/straps/Straight Shoulder Strap.png?v=1779738134',
    'Thin Strap': '/assets/Top/straps/Thin Strap.png?v=1779738134',
    'Twist Strap': '/assets/Top/straps/Twist Strap.png?v=1779738134',
    'Wide Strap': '/assets/Top/straps/Wide Strap.png?v=1779738134',
    'cross Multi Strap': '/assets/Top/straps/cross Multi Strap.png?v=1779738134',
  },
  openingCloser: {
    'Back Tie Closure': '/assets/Top/ Opening & closers/Back Tie Closure.png?v=1780660030',
    'Back Zip Closure': '/assets/Top/ Opening & closers/Back Zip Closure.png?v=1780660030',
    'Back Zipper Opening': '/assets/Top/ Opening & closers/Back Zipper Opening.png?v=1780660034',
    'Bow Tie Closure': '/assets/Top/ Opening & closers/Bow Tie Closure.png?v=1780660032',
    'Buckle Closure': '/assets/Top/ Opening & closers/Buckle Closure.png?v=1780660030',
    'Button Stand Opening': '/assets/Top/ Opening & closers/Button Stand Opening.png?v=1780660028',
    'Center Back Button Opening': '/assets/Top/ Opening & closers/Center Back Button Opening.png?v=1780660030',
    'Center Front Button Opening': '/assets/Top/ Opening & closers/Center Front Button Opening.png?v=1780660028',
    'Center Front Zipper': '/assets/Top/ Opening & closers/Center Front Zipper.png?v=1780660034',
    'Concealed Placket': '/assets/Top/ Opening & closers/Concealed Placket.png?v=1780660028',
    'Corset Hook Closure': '/assets/Top/ Opening & closers/Corset Hook Closure.png?v=1780660028',
    'D-Ring Closure': '/assets/Top/ Opening & closers/D-Ring Closure.png?v=1780660030',
    'Drawstring Closure': '/assets/Top/ Opening & closers/Drawstring Closure.png?v=1780660032',
    'Elastic Neck Opening': '/assets/Top/ Opening & closers/Elastic Neck Opening.png?v=1780660034',
    'Exposed Zipper': '/assets/Top/ Opening & closers/Exposed Zipper.png?v=1780660034',
    'Fabric Loop Closure': '/assets/Top/ Opening & closers/Fabric Loop Closure.png?v=1780660032',
    'Frog Closure': '/assets/Top/ Opening & closers/Frog Closure.png?v=1780660032',
    'Full Front Placket': '/assets/Top/ Opening & closers/Full Front Placket.png?v=1780660028',
    'Half Placket Opening': '/assets/Top/ Opening & closers/Half Placket Opening.png?v=1780660028',
    'Half Zip': '/assets/Top/ Opening & closers/Half Zip.png?v=1780660034',
    'Hook & Eye Closure': '/assets/Top/ Opening & closers/Hook & Eye Closure.png?v=1780660028',
    'Hook Bar Closure': '/assets/Top/ Opening & closers/Hook Bar Closure.png?v=1780660028',
    'Invisible Zipper': '/assets/Top/ Opening & closers/Invisible Zipper.png?v=1780660036',
    'Keyhole Back Opening': '/assets/Top/ Opening & closers/Keyhole Back Opening.png?v=1780660030',
    'Knot Closure': '/assets/Top/ Opening & closers/Knot Closure.png?v=1780660030',
    'Lace-Up Closure': '/assets/Top/ Opening & closers/Lace-Up Closure.png?v=1780660030',
    'Potli Button Loop': '/assets/Top/ Opening & closers/Potli Button Loop.png?v=1780660032',
    'Pull-On Opening': '/assets/Top/ Opening & closers/Pull-On Opening.png?v=1780660034',
    'Side Button Opening': '/assets/Top/ Opening & closers/Side Button Opening.png?v=1780660032',
    'Side Slit Opening': '/assets/Top/ Opening & closers/Side Slit Opening.png?v=1780660034',
    'Side Tie Closure': '/assets/Top/ Opening & closers/Side Tie Closure.png?v=1780660032',
    'Side Tie Opening': '/assets/Top/ Opening & closers/Side Tie Opening.png?v=1780660034',
    'Side Zipper Opening': '/assets/Top/ Opening & closers/Side Zipper Opening.png?v=1780660036',
    'Side zipOpening': '/assets/Top/ Opening & closers/Side zipOpening.png?v=1780660034',
    'Smocked Opening': '/assets/Top/ Opening & closers/Smocked Opening.png?v=1780660034',
    'Snap Button Opening': '/assets/Top/ Opening & closers/Snap Button Opening.png?v=1780660030',
    'Tie-Up Front Closure': '/assets/Top/ Opening & closers/Tie-Up Front Closure.png?v=1780660032',
    'Toggle Closure': '/assets/Top/ Opening & closers/Toggle Closure.png?v=1780660032',
    'Wrap Tie Closure': '/assets/Top/ Opening & closers/Wrap Tie Closure.png?v=1780660032',
  },
};

export const WOMEN_DRESS_ASSET_MAP = {
  necklineFront: {
    'Cowl Neck': '/assets/Dresses/necklines/Front/Cowl Neck.png?v=1780810448',
    'Crew neck': '/assets/Dresses/necklines/Front/Crew neck.png?v=1780810448',
    'Deep V neck': '/assets/Dresses/necklines/Front/Deep V neck.png?v=1780810448',
    'Draped Neck': '/assets/Dresses/necklines/Front/Draped Neck.png?v=1780810448',
    'Haltar Neck': '/assets/Dresses/necklines/Front/Haltar Neck.png?v=1780810448',
    'High Neck': '/assets/Dresses/necklines/Front/High Neck.png?v=1780810448',
    'Jewel neck': '/assets/Dresses/necklines/Front/Jewel neck.png?v=1780810448',
    'Keyhole Neck': '/assets/Dresses/necklines/Front/Keyhole Neck.png?v=1780810448',
    'Mandarin Neck': '/assets/Dresses/necklines/Front/Mandarin Neck.png?v=1780810448',
    'Notched Neck': '/assets/Dresses/necklines/Front/Notched Neck.png?v=1780810448',
    'Queen anne  Neck': '/assets/Dresses/necklines/Front/Queen anne  Neck.png?v=1780810450',
    'Rectangle Neck': '/assets/Dresses/necklines/Front/Rectangle Neck.png?v=1780810450',
    'Round neck': '/assets/Dresses/necklines/Front/Round neck.png?v=1780810450',
    'Sabrina neck': '/assets/Dresses/necklines/Front/Sabrina neck.png?v=1780810450',
    'Scalloped Neck': '/assets/Dresses/necklines/Front/Scalloped Neck.png?v=1780810450',
    'Scoop neck': '/assets/Dresses/necklines/Front/Scoop neck.png?v=1780810452',
    'Square Neck': '/assets/Dresses/necklines/Front/Square Neck.png?v=1780810452',
    'Surplice neck': '/assets/Dresses/necklines/Front/Surplice neck.png?v=1780810452',
    'Sweetheart neck': '/assets/Dresses/necklines/Front/Sweetheart neck.png?v=1780810452',
    'V neck': '/assets/Dresses/necklines/Front/V neck.png?v=1780810452',
    'bardot Neck': '/assets/Dresses/necklines/Front/bardot Neck.png?v=1780810446',
    'cold shoulder Neck': '/assets/Dresses/necklines/Front/cold shoulder Neck.png?v=1780810448',
    'illusion Neck': '/assets/Dresses/necklines/Front/illusion Neck.png?v=1780810448',
    'off - shoulder Neck': '/assets/Dresses/necklines/Front/off - shoulder Neck.png?v=1780810448',
    'one shoulder Neck': '/assets/Dresses/necklines/Front/one shoulder Neck.png?v=1780810448',
    'plunging neck': '/assets/Dresses/necklines/Front/plunging neck.png?v=1780810448',
    'portrait neck': '/assets/Dresses/necklines/Front/portrait neck.png?v=1780810450',
    'turle Neck': '/assets/Dresses/necklines/Front/turle Neck.png?v=1780810452',
  },
  necklineBack: {
    'Criss-Cross Back Cut-Out': '/assets/Dresses/necklines/back/Criss-Cross Back Cut-Out.png?v=1780810426',
    'Deep Back Cut-Out': '/assets/Dresses/necklines/back/Deep Back Cut-Out.png?v=1780810426',
    'Open Back Cut-Out': '/assets/Dresses/necklines/back/Open Back Cut-Out.png?v=1780810426',
    'Oval Back Cut-Out': '/assets/Dresses/necklines/back/Oval Back Cut-Out.png?v=1780810426',
    'Tie-Back Cut-Out': '/assets/Dresses/necklines/back/Tie-Back Cut-Out.png?v=1780810426',
  },
  sleeve: {
    'Angle sleeves': '/assets/Dresses/sleeves/Angle sleeves.png?v=1780810502',
    'Batwing sleeve': '/assets/Dresses/sleeves/Batwing sleeve.png?v=1780810502',
    'Bell sleeves': '/assets/Dresses/sleeves/Bell sleeves.png?v=1780810504',
    'Butterfly sleeves': '/assets/Dresses/sleeves/Butterfly sleeves.png?v=1780810502',
    'Cap Sleeves': '/assets/Dresses/sleeves/Cap Sleeves.png?v=1780810502',
    'Dolman sleeve': '/assets/Dresses/sleeves/Dolman sleeve.png?v=1780810502',
    'Flared peplum sleeves': '/assets/Dresses/sleeves/Flared peplum sleeves.png?v=1780810502',
    'Flounce sleeves': '/assets/Dresses/sleeves/Flounce sleeves.png?v=1780810502',
    'Flute sleeves': '/assets/Dresses/sleeves/Flute sleeves.png?v=1780810502',
    'Flutter sleeves (2)': '/assets/Dresses/sleeves/Flutter sleeves (2).png?v=1780810504',
    'Flutter sleeves': '/assets/Dresses/sleeves/Flutter sleeves.png?v=1780810502',
    'Full Sleeves': '/assets/Dresses/sleeves/Full Sleeves.png?v=1780810504',
    'Gigot sleeve': '/assets/Dresses/sleeves/Gigot sleeve.png?v=1780810502',
    'Half Sleeves': '/assets/Dresses/sleeves/Half Sleeves.png?v=1780810504',
    'Kimono sleeve': '/assets/Dresses/sleeves/Kimono sleeve.png?v=1780810504',
    'Leg-o-mutton sleeves': '/assets/Dresses/sleeves/Leg-o-mutton sleeves.png?v=1780810506',
    'Medieval sleeves': '/assets/Dresses/sleeves/Medieval sleeves.png?v=1780810506',
    'Raglan sleeve': '/assets/Dresses/sleeves/Raglan sleeve.png?v=1780810506',
    'Ruched sleeves': '/assets/Dresses/sleeves/Ruched sleeves.png?v=1780810506',
    'Shirred sleeves': '/assets/Dresses/sleeves/Shirred sleeves.png?v=1780810506',
    'Short Sleeves': '/assets/Dresses/sleeves/Short Sleeves.png?v=1780810506',
    Sleeveless: '/assets/Dresses/sleeves/Sleeveless.png?v=1780810506',
    'Slit sleeves': '/assets/Dresses/sleeves/Slit sleeves.png?v=1780810506',
    'Smocked sleeves': '/assets/Dresses/sleeves/Smocked sleeves.png?v=1780810506',
    'Three quarter Sleeves': '/assets/Dresses/sleeves/Three quarter Sleeves.png?v=1780810508',
    'Tiered sleeves': '/assets/Dresses/sleeves/Tiered sleeves.png?v=1780810508',
    'bishop sleeves': '/assets/Dresses/sleeves/bishop sleeves.png?v=1780810502',
    'cape sleeves': '/assets/Dresses/sleeves/cape sleeves.png?v=1780810504',
    'juliette sleeves': '/assets/Dresses/sleeves/juliette sleeves.png?v=1780810504',
    'lantern sleeves': '/assets/Dresses/sleeves/lantern sleeves.png?v=1780810506',
    'open sleeves': '/assets/Dresses/sleeves/open sleeves.png?v=1780810506',
    'petal sleeves': '/assets/Dresses/sleeves/petal sleeves.png?v=1780810506',
    'poet sleeves': '/assets/Dresses/sleeves/poet sleeves.png?v=1780810506',
    'puff sleeve': '/assets/Dresses/sleeves/puff sleeve.png?v=1780810506',
    'tulip sleeves': '/assets/Dresses/sleeves/tulip sleeves.png?v=1780810508',
  },
  length: {
    'Calf length': '/assets/Dresses/Lengths/Calf length.png?v=1780810180',
    'Floor length': '/assets/Dresses/Lengths/Floor length.png?v=1780810180',
    'Knee length': '/assets/Dresses/Lengths/Knee length.png?v=1780810180',
    Mini: '/assets/Dresses/Lengths/Mini.png?v=1780810180',
  },
  bodice: {
    'Fitted bodice': '/assets/Dresses/Bodies/Fitted bodice.png?v=1780810262',
    'Panelled bodice': '/assets/Dresses/Bodies/Panelled bodice.png?v=1780810262',
    'Relaxed bodice': '/assets/Dresses/Bodies/Relaxed bodice.png?v=1780810262',
    'Smocked bodice': '/assets/Dresses/Bodies/Smocked bodice.png?v=1780810262',
    'Structured bodice': '/assets/Dresses/Bodies/Structured bodice.png?v=1780810262',
    'Wrap bodice': '/assets/Dresses/Bodies/Wrap bodice.png?v=1780810262',
  },
  bodyCutOut: {
    'Chest Cut-Out': '/assets/Dresses/body cut outs/Chest Cut-Out.png?v=1780789548',
    'Deep V Cut-Out': '/assets/Dresses/body cut outs/Deep V Cut-Out.png?v=1780789548',
    'Double Waist Cut-Out': '/assets/Dresses/body cut outs/Double Waist Cut-Out.png?v=1780789548',
    'Front Cut-Out': '/assets/Dresses/body cut outs/Front Cut-Out.png?v=1780789548',
    'Geometric Side Cut-Out': '/assets/Dresses/body cut outs/Geometric Side Cut-Out.png?v=1780789548',
    'Hem & Side Cut-Outs': '/assets/Dresses/body cut outs/Hem & Side Cut-Outs.png?v=1780789548',
    'Hip Cut-Out': '/assets/Dresses/body cut outs/Hip Cut-Out.png?v=1780789548',
    'Midriff Cut-Out': '/assets/Dresses/body cut outs/Midriff Cut-Out.png?v=1780789548',
    'Peek-a-Boo Cut-Out': '/assets/Dresses/body cut outs/Peek-a-Boo Cut-Out.png?v=1780789548',
    'Ring Waist Cut-Out': '/assets/Dresses/body cut outs/Ring Waist Cut-Out.png?v=1780789548',
    'Side Slit Cut-Out': '/assets/Dresses/body cut outs/Side Slit Cut-Out.png?v=1780789550',
    'Side Waist Cut-Out': '/assets/Dresses/body cut outs/Side Waist Cut-Out.png?v=1780789550',
    'Thigh Cut-Out': '/assets/Dresses/body cut outs/Thigh Cut-Out.png?v=1780789550',
  },
  waistAttachment: {
    'Belted Waist': '/assets/Dresses/Waist Attachments/Belted Waist.png?v=1780809640',
    'Drawstring Waist': '/assets/Dresses/Waist Attachments/Drawstring Waist.png?v=1780809640',
    'Elastic Waistband': '/assets/Dresses/Waist Attachments/Elastic Waistband.png?v=1780809640',
    'Gathered Waist': '/assets/Dresses/Waist Attachments/Gathered Waist.png?v=1780809640',
    'Paperbag Waist': '/assets/Dresses/Waist Attachments/Paperbag Waist.png?v=1780809640',
    'Peplum Attachment': '/assets/Dresses/Waist Attachments/Peplum Attachment.png?v=1780809640',
    'Smocked Waist': '/assets/Dresses/Waist Attachments/Smocked Waist.png?v=1780809640',
    'Tie Waist': '/assets/Dresses/Waist Attachments/Tie Waist.png?v=1780809640',
    Waistband: '/assets/Dresses/Waist Attachments/Waistband.png?v=1780809640',
    'Wrap Waist': '/assets/Dresses/Waist Attachments/Wrap Waist.png?v=1780809640',
  },
  waistPlacement: {
    'Above waist (Empire)': '/assets/Dresses/Waise placement/Above waist (Empire).png?v=1780810348',
    'Dropped waist': '/assets/Dresses/Waise placement/Dropped waist.png?v=1780810348',
    'High waist': '/assets/Dresses/Waise placement/High waist.png?v=1780810350',
    'Natural waist': '/assets/Dresses/Waise placement/Natural waist.png?v=1780810350',
    'No waist': '/assets/Dresses/Waise placement/No waist.png?v=1780810350',
  },
  shoulderDetail: {
    'Basic Shoulder Styles': '/assets/Dresses/shoulder details/Basic Shoulder Styles.png?v=1780789568',
    'Bow Shoulder': '/assets/Dresses/shoulder details/Bow Shoulder.png?v=1780789568',
    'Dropped Shoulder': '/assets/Dresses/shoulder details/Dropped Shoulder.png?v=1780789568',
    'Epaulette Shoulder': '/assets/Dresses/shoulder details/Epaulette Shoulder.png?v=1780789568',
    'Military Shoulder': '/assets/Dresses/shoulder details/Military Shoulder.png?v=1780789568',
    'Narrow Shoulder': '/assets/Dresses/shoulder details/Narrow Shoulder.png?v=1780789568',
    'Padded Shoulder': '/assets/Dresses/shoulder details/Padded Shoulder.png?v=1780789570',
    'Regular Shoulder': '/assets/Dresses/shoulder details/Regular Shoulder.png?v=1780789570',
    'Sculpted Shoulder': '/assets/Dresses/shoulder details/Sculpted Shoulder.png?v=1780789570',
    'Sharp Shoulder': '/assets/Dresses/shoulder details/Sharp Shoulder.png?v=1780789570',
    'Structured Shoulder': '/assets/Dresses/shoulder details/Structured Shoulder.png?v=1780789570',
    'Tie-Up Shoulder': '/assets/Dresses/shoulder details/Tie-Up Shoulder.png?v=1780789570',
    'Winged Shoulder': '/assets/Dresses/shoulder details/Winged Shoulder.png?v=1780789570',
  },
  surfaceVolume: {
    'Box Tucks': '/assets/Dresses/surface - volume details/Box Tucks.png?v=1780789570',
    'Diagonal Tucks': '/assets/Dresses/surface - volume details/Diagonal Tucks.png?v=1780789570',
    'Parallel Tucks': '/assets/Dresses/surface - volume details/Parallel Tucks.png?v=1780789572',
    'Pin Tucks': '/assets/Dresses/surface - volume details/Pin Tucks.png?v=1780789572',
    'Release Tucks': '/assets/Dresses/surface - volume details/Release Tucks.png?v=1780789572',
    'Shoulder Tucks': '/assets/Dresses/surface - volume details/Shoulder Tucks.png?v=1780789572',
    'Waterfall Ruffle': '/assets/Dresses/surface - volume details/Waterfall Ruffle.png?v=1780789572',
  },
  strap: {
    'Adjustable Strap': '/assets/Dresses/strap variations/Adjustable Strap.png?v=1780809702',
    'Around-Neck Strap': '/assets/Dresses/strap variations/Around-Neck Strap.png?v=1780809702',
    'Beaded Strap': '/assets/Dresses/strap variations/Beaded Strap.png?v=1780809700',
    'Bow Strap': '/assets/Dresses/strap variations/Bow Strap.png?v=1780809702',
    'Braided Strap': '/assets/Dresses/strap variations/Braided Strap.png?v=1780809702',
    'Buckle Strap': '/assets/Dresses/strap variations/Buckle Strap.png?v=1780809702',
    'Cage Strap': '/assets/Dresses/strap variations/Cage Strap.png?v=1780809702',
    'Chain Strap': '/assets/Dresses/strap variations/Chain Strap.png?v=1780809702',
    'Corset Strap': '/assets/Dresses/strap variations/Corset Strap.png?v=1780809702',
    'Criss-Cross Strap': '/assets/Dresses/strap variations/Criss-Cross Strap.png?v=1780809702',
    'Cross Neck Strap': '/assets/Dresses/strap variations/Cross Neck Strap.png?v=1780809702',
    'Cut-Out Strap': '/assets/Dresses/strap variations/Cut-Out Strap.png?v=1780809702',
    'Double Strap': '/assets/Dresses/strap variations/Double Strap.png?v=1780809702',
    'Gathered Strap': '/assets/Dresses/strap variations/Gathered Strap.png?v=1780809702',
    'Halter Strap': '/assets/Dresses/strap variations/Halter Strap.png?v=1780809702',
    'Harness Strap (2)': '/assets/Dresses/strap variations/Harness Strap (2).png?v=1780809704',
    'Harness Strap': '/assets/Dresses/strap variations/Harness Strap.png?v=1780809704',
    'Knot Strap': '/assets/Dresses/strap variations/Knot Strap.png?v=1780809704',
    'Medium Strap': '/assets/Dresses/strap variations/Medium Strap.png?v=1780809704',
    'Multi Strap': '/assets/Dresses/strap variations/Multi Strap.png?v=1780809704',
    'Neck Tie Strap': '/assets/Dresses/strap variations/Neck Tie Strap.png?v=1780809704',
    'Off-Shoulder Strap': '/assets/Dresses/strap variations/Off-Shoulder Strap.png?v=1780809704',
    'One-Shoulder Strap': '/assets/Dresses/strap variations/One-Shoulder Strap.png?v=1780809704',
    'Racerback Strap': '/assets/Dresses/strap variations/Racerback Strap.png?v=1780809704',
    'Ruffle Strap': '/assets/Dresses/strap variations/Ruffle Strap.png?v=1780809704',
    'Straight Shoulder Strap': '/assets/Dresses/strap variations/Straight Shoulder Strap.png?v=1780809704',
    'Thin Strap': '/assets/Dresses/strap variations/Thin Strap.png?v=1780809704',
    'Twist Strap': '/assets/Dresses/strap variations/Twist Strap.png?v=1780809704',
    'Wide Strap': '/assets/Dresses/strap variations/Wide Strap.png?v=1780809704',
    'cross Multi Strap': '/assets/Dresses/strap variations/cross Multi Strap.png?v=1780809702',
  },
  flareVariation: {
    '180 ( semi circle)_': '/assets/Dresses/flare variations/180 ( semi circle)_.png?v=1780789550',
    'Accordion pleated_': '/assets/Dresses/flare variations/Accordion pleated_.png?v=1780789550',
    'Box pleated_': '/assets/Dresses/flare variations/Box pleated_.png?v=1780789550',
    Circle: '/assets/Dresses/flare variations/Circle.png?v=1780789550',
    Flared_: '/assets/Dresses/flare variations/Flared_.png?v=1780789550',
    'Four flair_': '/assets/Dresses/flare variations/Four flair_.png?v=1780789550',
    Gathered_: '/assets/Dresses/flare variations/Gathered_.png?v=1780789550',
    Godet_: '/assets/Dresses/flare variations/Godet_.png?v=1780789550',
    'Handkerchief Hem flair_': '/assets/Dresses/flare variations/Handkerchief Hem flair_.png?v=1780789550',
    'Knife pleated_': '/assets/Dresses/flare variations/Knife pleated_.png?v=1780789550',
    'Low gathered_': '/assets/Dresses/flare variations/Low gathered_.png?v=1780789550',
    Mermaid_: '/assets/Dresses/flare variations/Mermaid_.png?v=1780789552',
    Pleated_: '/assets/Dresses/flare variations/Pleated_.png?v=1780789552',
    'Sunray pleated': '/assets/Dresses/flare variations/Sunray pleated.png?v=1780789552',
    Tiered: '/assets/Dresses/flare variations/Tiered.png?v=1780789552',
  },
  slitVariationLength: {
    'Deep Slit': '/assets/Dresses/slit veriations/length/Deep Slit.png?v=1780809798',
    'Floor-Length Slit': '/assets/Dresses/slit veriations/length/Floor-Length Slit.png?v=1780809798',
    'Knee-High Slit': '/assets/Dresses/slit veriations/length/Knee-High Slit.png?v=1780809800',
    'Short Slit': '/assets/Dresses/slit veriations/length/Short Slit.png?v=1780809800',
    'Thigh-High Slit': '/assets/Dresses/slit veriations/length/Thigh-High Slit.png?v=1780809800',
  },
  slitVariationTypes: {
    'Back Slit': '/assets/Dresses/slit veriations/types/Back Slit.png?v=1780809774',
    'Buttoned Slit': '/assets/Dresses/slit veriations/types/Buttoned Slit.png?v=1780809774',
    'Curved Slit': '/assets/Dresses/slit veriations/types/Curved Slit.png?v=1780809774',
    'Frill Slit': '/assets/Dresses/slit veriations/types/Frill Slit.png?v=1780809774',
    'Front Slit (2)': '/assets/Dresses/slit veriations/types/Front Slit (2).png?v=1780809774',
    'Front Slit': '/assets/Dresses/slit veriations/types/Front Slit.png?v=1780809774',
    'Ruffle Slit': '/assets/Dresses/slit veriations/types/Ruffle Slit.png?v=1780809774',
    'Side Slit': '/assets/Dresses/slit veriations/types/Side Slit.png?v=1780809774',
  },
};

export const WOMEN_TRADITIONAL_BOTTOMS_ASSET_MAP = {
  style: {
    'Afghani salwar_': '/assets/Traditional Bottoms /Bottoms /Afghani salwar_.png?v=1780991334',
    'Anarkali bottom_': '/assets/Traditional Bottoms /Bottoms /Anarkali bottom_.png?v=1780991334',
    Churidar_: '/assets/Traditional Bottoms /Bottoms /Churidar_.png?v=1780991334',
    Cigarette_: '/assets/Traditional Bottoms /Bottoms /Cigarette_.png?v=1780991334',
    'Dhoti salwar_': '/assets/Traditional Bottoms /Bottoms /Dhoti salwar_.png?v=1780991336',
    Pajama_: '/assets/Traditional Bottoms /Bottoms /Pajama_.png?v=1780991336',
    Palazzo: '/assets/Traditional Bottoms /Bottoms /Palazzo.png?v=1780991336',
    'Parallel pants_': '/assets/Traditional Bottoms /Bottoms /Parallel pants_.png?v=1780991336',
    'Patiala salwar_': '/assets/Traditional Bottoms /Bottoms /Patiala salwar_.png?v=1780991336',
    Sharara_: '/assets/Traditional Bottoms /Bottoms /Sharara_.png?v=1780991336',
    'Straight salwar_': '/assets/Traditional Bottoms /Bottoms /Straight salwar_.png?v=1780991336',
    'Tulip salwar_': '/assets/Traditional Bottoms /Bottoms /Tulip salwar_.png?v=1780991336',
  },
  waistband: {
    'Curved waistband_': '/assets/Traditional Bottoms /Waist band /Curved waistband_.png?v=1780991338',
    'Drawstring waistband_': '/assets/Traditional Bottoms /Waist band /Drawstring waistband_.png?v=1780991340',
    'Elastic Waistband': '/assets/Traditional Bottoms /Waist band /Elastic waistband.png?v=1780991340',
    'Elastic wist drawstring_': '/assets/Traditional Bottoms /Waist band /Elastic wist drawstring_.png?v=1780991340',
    'Embellished waistband_': '/assets/Traditional Bottoms /Waist band /Embellished waistband_.png?v=1780991340',
    'Front Flat & Back elastic_': '/assets/Traditional Bottoms /Waist band /Front Flat & Back elastic_.png?v=1780991340',
    'Gathered into bands_': '/assets/Traditional Bottoms /Waist band /Gathered into bands_.png?v=1780991340',
    'Overlap with button_': '/assets/Traditional Bottoms /Waist band /Overlap with button_.png?v=1780991340',
    'Piped waist band_': '/assets/Traditional Bottoms /Waist band /Piped waist band_.png?v=1780991340',
    'Plain waist band_': '/assets/Traditional Bottoms /Waist band /Plain waist band_.png?v=1780991342',
    'Smocked Waistband_': '/assets/Traditional Bottoms /Waist band /Smocked Waistband_.png?v=1780991342',
    'V shape waist band_': '/assets/Traditional Bottoms /Waist band /V shape waist band_.png?v=1780991342',
    'Waistband with belt loop_': '/assets/Traditional Bottoms /Waist band /Waistband with belt loop_.png?v=1780991342',
    'Wide waistband_': '/assets/Traditional Bottoms /Waist band /Wide waistband_.png?v=1780991342',
    'Wrap & Tie Waistband_': '/assets/Traditional Bottoms /Waist band /Wrap & Tie Waistband_.png?v=1780991342',
  },
  pocket: {
    'Cargo style pocket_': '/assets/Traditional Bottoms /Pockets /Cargo style pocket_.png?v=1780991336',
    'Flap pocket_': '/assets/Traditional Bottoms /Pockets /Flap pocket_.png?v=1780991336',
    'Hidden pocket_': '/assets/Traditional Bottoms /Pockets /Hidden pocket_.png?v=1780991338',
    'Inset pocket_': '/assets/Traditional Bottoms /Pockets /Inset pocket_.png?v=1780991338',
    'Patch Pocket_(1)': '/assets/Traditional Bottoms /Pockets /Patch Pocket_(1).png?v=1780991338',
    'Patch pocket_': '/assets/Traditional Bottoms /Pockets /Patch pocket_.png?v=1780991338',
    'Side seam pocket_': '/assets/Traditional Bottoms /Pockets /Side seam pocket_.png?v=1780991338',
    'Slant pocket_': '/assets/Traditional Bottoms /Pockets /Slant pocket_.png?v=1780991338',
    'Tie up pocket_': '/assets/Traditional Bottoms /Pockets /Tie up pocket_.png?v=1780991338',
  },
};

export const WOMEN_BLOUSES_ASSET_MAP = {
  sleeve: {
    '3_4th Sleeve': '/assets/Blouses/Sleeves/3_4th Sleeve.png?v=1779801102',
    'Bishop Sleeve': '/assets/Blouses/Sleeves/Bishop Sleeve.png?v=1779801102',
    'Cap Sleeve': '/assets/Blouses/Sleeves/Cap Sleeve.png?v=1779801102',
    'Cold Shoulder Sleeve': '/assets/Blouses/Sleeves/Cold Shoulder Sleeve.png?v=1779801102',
    'Criss-Cross Sleeve': '/assets/Blouses/Sleeves/Criss-Cross Sleeve.png?v=1779801102',
    'Detachable Sleeve': '/assets/Blouses/Sleeves/Detachable Sleeve.png?v=1779801102',
    'Elbow Sleeve': '/assets/Blouses/Sleeves/Elbow Sleeve.png?v=1779801102',
    'Flutter Sleeve': '/assets/Blouses/Sleeves/Flutter Sleeve.png?v=1779801102',
    'Full Sleeve': '/assets/Blouses/Sleeves/Full Sleeve.png?v=1779801102',
    'Gathered Sleeve': '/assets/Blouses/Sleeves/Gathered Sleeve.png?v=1779801102',
    'Open Sleeve': '/assets/Blouses/Sleeves/Open Sleeve.png?v=1779801102',
    'Pleated Sleeve': '/assets/Blouses/Sleeves/Pleated Sleeve.png?v=1779801102',
    'Puff Sleeve': '/assets/Blouses/Sleeves/Puff Sleeve.png?v=1779801102',
    'Ruffle Sleeve': '/assets/Blouses/Sleeves/Ruffle Sleeve.png?v=1779801102',
    'Short Sleeve': '/assets/Blouses/Sleeves/Short Sleeve.png?v=1779801102',
    Sleeveless: '/assets/Blouses/Sleeves/Sleeveless.png?v=1779801102',
    'Slit Sleeve': '/assets/Blouses/Sleeves/Slit Sleeve.png?v=1779801102',
    'Spaghetti Strap': '/assets/Blouses/Sleeves/Spaghetti Strap.png?v=1779801102',
  },
  backNeck: {
    'Boat Back': '/assets/Blouses/neck/back neck/Boat Back.png?v=1779801102',
    'Closed Back': '/assets/Blouses/neck/back neck/Closed Back.png?v=1779801102',
    'Collar Back': '/assets/Blouses/neck/back neck/Collar Back.png?v=1779801102',
    'Cutout Back': '/assets/Blouses/neck/back neck/Cutout Back.png?v=1779801102',
    'Diamond Back': '/assets/Blouses/neck/back neck/Diamond Back.png?v=1779801102',
    'Dori Back (Tie-Up Back)': '/assets/Blouses/neck/back neck/Dori Back (Tie-Up Back).png?v=1779801102',
    'Halter Neck Back': '/assets/Blouses/neck/back neck/Halter Neck Back.png?v=1779801102',
    'Keyhole Back': '/assets/Blouses/neck/back neck/Keyhole Back.png?v=1779801102',
    'Knot Back': '/assets/Blouses/neck/back neck/Knot Back.png?v=1779801102',
    'Lace-Up Back': '/assets/Blouses/neck/back neck/Lace-Up Back.png?v=1779801102',
    'Leaf Shape Back': '/assets/Blouses/neck/back neck/Leaf Shape Back.png?v=1779801102',
    'Peek-a-Boo Back': '/assets/Blouses/neck/back neck/Peek-a-Boo Back.png?v=1779801102',
    'Pentagon Back': '/assets/Blouses/neck/back neck/Pentagon Back.png?v=1779801102',
    'Round neck': '/assets/Blouses/neck/back neck/Round neck.png?v=1779801102',
    'Scallop Back': '/assets/Blouses/neck/back neck/Scallop Back.png?v=1779801102',
    'Square Back': '/assets/Blouses/neck/back neck/Square Back.png?v=1779801102',
    'Teardrop Back': '/assets/Blouses/neck/back neck/Teardrop Back.png?v=1779801102',
    'U Back': '/assets/Blouses/neck/back neck/U Back.png?v=1779801102',
    'V Back': '/assets/Blouses/neck/back neck/V Back.png?v=1779801102',
    'Window Cut Back': '/assets/Blouses/neck/back neck/Window Cut Back.png?v=1779801102',
  },
  closure: {
    'Back Hook Closure': '/assets/Blouses/Opening and closer/Closure/Back Hook Closure.png?v=1779801101',
    'Back Zip Closure': '/assets/Blouses/Opening and closer/Closure/Back Zip Closure.png?v=1779801101',
    'Corset Lace-Up Closure': '/assets/Blouses/Opening and closer/Closure/Corset Lace-Up Closure.png?v=1779801101',
    'Keyhole Button Closure': '/assets/Blouses/Opening and closer/Closure/Keyhole Button Closure.png?v=1779801101',
    'Knot Tie Closure': '/assets/Blouses/Opening and closer/Closure/Knot Tie Closure.png?v=1779801101',
    'Smocked Back Closure': '/assets/Blouses/Opening and closer/Closure/Smocked Back Closure.png?v=1779801101',
  },
  frontOpening: {
    'Front Hook Closure': '/assets/Blouses/Opening and closer/front Opening/Front Hook Closure.png?v=1779801101',
    'Front Zip Closure': '/assets/Blouses/Opening and closer/front Opening/Front Zip Closure.png?v=1779801101',
    'Side Zip Closure': '/assets/Blouses/Opening and closer/front Opening/Side Zip Closure.png?v=1779801101',
    'Wrap Closure': '/assets/Blouses/Opening and closer/front Opening/Wrap Closure.png?v=1779801101',
  },
};

export const WOMEN_SAREE_STYLES_ASSET_MAP = {
  drapingStyle: {
    Aasami: '/assets/saree styles/Aasami.png?v=1779801102',
    'Bhootheyara - karnataka': '/assets/saree styles/Bhootheyara - karnataka.png?v=1779801102',
    Brahamani: '/assets/saree styles/Brahamani.png?v=1779801102',
    Chattisgarh: '/assets/saree styles/Chattisgarh.png?v=1779801102',
    'Ghorapandha - odisha': '/assets/saree styles/Ghorapandha - odisha.png?v=1779801102',
    'Goa — Kunbi Draping Style': '/assets/saree styles/Goa — Kunbi Draping Style.png?v=1779801102',
    'Halaki vokkaliga - karnataka': '/assets/saree styles/Halaki vokkaliga - karnataka.png?v=1779801102',
    Karnataka: '/assets/saree styles/Karnataka.png?v=1779801102',
    'Kerala — Set Mundu Style': '/assets/saree styles/Kerala — Set Mundu Style.png?v=1779801102',
    Kotapad: '/assets/saree styles/Kotapad.png?v=1779801102',
    'Maharashtrian nauvari': '/assets/saree styles/Maharashtrian nauvari.png?v=1779801102',
    'Phanek Style - manipur': '/assets/saree styles/Phanek Style - manipur.png?v=1779801102',
    'Rignai Style - tripura': '/assets/saree styles/Rignai Style - tripura.png?v=1779801102',
    Tamil: '/assets/saree styles/Tamil.png?v=1779801102',
    'Uttar Pradesh — Ulta Pallu Style': '/assets/saree styles/Uttar Pradesh — Ulta Pallu Style.png?v=1779801102',
    'West Bengal — Atpoure Style': '/assets/saree styles/West Bengal — Atpoure Style.png?v=1779801102',
    'kaccha - odisha': '/assets/saree styles/kaccha - odisha.png?v=1779801102',
    'kodva - karnataka': '/assets/saree styles/kodva - karnataka.png?v=1779801102',
    'madhava kachhe - karnataka': '/assets/saree styles/madhava kachhe - karnataka.png?v=1779801102',
    'santhal Dreap': '/assets/saree styles/santhal Dreap.png?v=1779801102',
  },
};

export const WOMEN_LEHENGA_ASSET_MAP = {
  pleatedType: {
    '12 pleated lehenga_': '/assets/Lehenga /Pleated lehenga type /12 pleated lehenga_.png?v=1780991330',
    '6 pleated lehenga_': '/assets/Lehenga /Pleated lehenga type /6 pleated lehenga_.png?v=1780991330',
    'Embroidered 4 leat lehenga_': '/assets/Lehenga /Pleated lehenga type /Embroidered 4 leat lehenga_.png?v=1780991330',
    'Florals border lehenga_': '/assets/Lehenga /Pleated lehenga type /Florals border lehenga_.png?v=1780991332',
    'Panel Arch hem_': '/assets/Lehenga /Pleated lehenga type /Panel Arch hem_.png?v=1780991332',
    'Ruffle lehenga_': '/assets/Lehenga /Pleated lehenga type /Ruffle lehenga_.png?v=1780991332',
  },
  hem: {
    'Cutwork hem_': '/assets/Lehenga /Hem variation /Cutwork hem_.png?v=1780991332',
    'Double border ': '/assets/Lehenga /Hem variation /Double border .png?v=1780991332',
    'Jaal hem_': '/assets/Lehenga /Hem variation /Jaal hem_.png?v=1780991332',
    'Narrow Border_': '/assets/Lehenga /Hem variation /Narrow Border_.png?v=1780991332',
    'Overlaped scallop hem_': '/assets/Lehenga /Hem variation /Overlaped scallop hem_.png?v=1780991332',
    'Pleated hem_': '/assets/Lehenga /Hem variation /Pleated hem_.png?v=1780991334',
    'Ruffle hem_': '/assets/Lehenga /Hem variation /Ruffle hem_.png?v=1780991334',
    'Scallops edge_': '/assets/Lehenga /Hem variation /Scallops edge_.png?v=1780991334',
    'Tassel hem_': '/assets/Lehenga /Hem variation /Tassel hem_.png?v=1780991334',
  },
  waistband: {
    'Curved waistband_': '/assets/Lehenga /Waist band /Curved waistband_.jpg?v=1779801102',
    'Drawstring waistband_': '/assets/Lehenga /Waist band /Drawstring waistband_.jpg?v=1779801102',
    'Elastic waistband': '/assets/Lehenga /Waist band /Elastic waistband.jpg?v=1779801102',
    'Elastic wist drawstring_': '/assets/Lehenga /Waist band /Elastic wist drawstring_.jpg?v=1779801102',
    'Embellished waistband_': '/assets/Lehenga /Waist band /Embellished waistband_.jpg?v=1779801102',
    'Front Flat & Back elastic_': '/assets/Lehenga /Waist band /Front Flat & Back elastic_.jpg?v=1779801102',
    'Gathered into bands_': '/assets/Lehenga /Waist band /Gathered into bands_.jpg?v=1779801102',
    'Overlap with button_': '/assets/Lehenga /Waist band /Overlap with button_.jpg?v=1779801102',
    'Piped waist band_': '/assets/Lehenga /Waist band /Piped waist band_.jpg?v=1779801102',
    'Plain waist band_': '/assets/Lehenga /Waist band /Plain waist band_.jpg?v=1779801102',
    'Smocked Waistband_': '/assets/Lehenga /Waist band /Smocked Waistband_.jpg?v=1779801102',
    'V shape waist band_': '/assets/Lehenga /Waist band /V shape waist band_.jpg?v=1779801102',
    'Waistband with belt loop_': '/assets/Lehenga /Waist band /Waistband with belt loop_.jpg?v=1779801102',
    'Wide waistband_': '/assets/Lehenga /Waist band /Wide waistband_.jpg?v=1779801102',
    'Wrap & Tie Waistband_': '/assets/Lehenga /Waist band /Wrap & Tie Waistband_.jpg?v=1779801102',
  },
  pocket: {
    'Cargo style pocket_': '/assets/Lehenga /Pockets /Cargo style pocket_.jpg?v=1779801102',
    'Flap pocket_': '/assets/Lehenga /Pockets /Flap pocket_.jpg?v=1779801102',
    'Hidden pocket_': '/assets/Lehenga /Pockets /Hidden pocket_.jpg?v=1779801102',
    'Inset pocket_': '/assets/Lehenga /Pockets /Inset pocket_.jpg?v=1779801102',
    'Patch Pocket_(1)': '/assets/Lehenga /Pockets /Patch Pocket_(1).jpg?v=1779801102',
    'Patch pocket_': '/assets/Lehenga /Pockets /Patch pocket_.jpg?v=1779801102',
    'Side seam pocket_': '/assets/Lehenga /Pockets /Side seam pocket_.jpg?v=1779801102',
    'Slant pocket_': '/assets/Lehenga /Pockets /Slant pocket_.jpg?v=1779801102',
    'Tie up pocket_': '/assets/Lehenga /Pockets /Tie up pocket_.jpg?v=1779801102',
  },
};

export const WOMEN_NIGHT_WEAR_ASSET_MAP = {
  frontPanel: {
    'Baby dolls_': '/assets/Night wear /Front panel /Baby dolls_.png?v=1781436270',
    'Camisole and short set_': '/assets/Night wear /Front panel /Camisole and short set_.png?v=1781436270',
    'Classic pajama set_': '/assets/Night wear /Front panel /Classic pajama set_.png?v=1781436272',
    'Henley top and pant set_': '/assets/Night wear /Front panel /Henley top and pant set_.png?v=1781436272',
    'Kimono robe_': '/assets/Night wear /Front panel /Kimono robe_.png?v=1781436272',
    'Long night gown_': '/assets/Night wear /Front panel /Long night gown_.png?v=1781436272',
    'Maternity night wear_': '/assets/Night wear /Front panel /Maternity night wear_.png?v=1781436272',
    'Nursing nightwear_': '/assets/Night wear /Front panel /Nursing nightwear_.png?v=1781436272',
    'Short night dress_': '/assets/Night wear /Front panel /Short night dress_.png?v=1781436272',
    'Short sleeve pajama set_': '/assets/Night wear /Front panel /Short sleeve pajama set_.png?v=1781436272',
    'Sleep shirt_': '/assets/Night wear /Front panel /Sleep shirt_.png?v=1781436272',
    'Slip night_': '/assets/Night wear /Front panel /Slip night_.png?v=1781436272',
    'Winter lounge wear_': '/assets/Night wear /Front panel /Winter lounge wear_.png?v=1781436274',
    'Wrap robe_': '/assets/Night wear /Front panel /Wrap robe_.png?v=1781436274',
  },
};

export const WOMEN_LINGERIE_ASSET_MAP = {
  style: {
    'Asymmetric hem_': '/assets/Lingerie /Asymmetric hem_.png?v=1781172706',
    Bandeau_: '/assets/Lingerie /Bandeau_.png?v=1781172708',
    'Crossover wrap_': '/assets/Lingerie /Crossover wrap_.png?v=1781172708',
    'Empire waist Flowy_': '/assets/Lingerie /Empire waist Flowy_.png?v=1781172708',
    'Halter key hole_': '/assets/Lingerie /Halter key hole_.png?v=1781172708',
    'Long lining corset bra_': '/assets/Lingerie /Long lining corset bra_.png?v=1781172708',
    'One shoulder asymmetry_': '/assets/Lingerie /One shoulder asymmetry_.png?v=1781172708',
    'Panel contrast_': '/assets/Lingerie /Panel contrast_.png?v=1781172708',
    'Ruffle Tierd_': '/assets/Lingerie /Ruffle Tierd_.png?v=1781172708',
    'Ruffle tiered_': '/assets/Lingerie /Ruffle tiered_.png?v=1781172710',
    'Strappy cage_': '/assets/Lingerie /Strappy cage_.png?v=1781172710',
    'Stray details_': '/assets/Lingerie /Stray details_.png?v=1781172710',
  },
};

export const WOMEN_BLAZER_ASSET_MAP = {
  shape: {
    'Classic Notched_': '/assets/Blazer /Shapes/Classic Notched_.png?v=1783694108',
    'Collarless (crew neck)': '/assets/Blazer /Shapes/Collarless (crew neck).png?v=1783694056',
    Cropped: '/assets/Blazer /Shapes/Cropped.png?v=1783693922',
    'Double Breasted_': '/assets/Blazer /Shapes/Double Breasted_.png?v=1783693948',
    'Peak lapel': '/assets/Blazer /Shapes/Peak lapel.png?v=1783694074',
    'Tuxedo (satin Lapels)': '/assets/Blazer /Shapes/Tuxedo (satin Lapels).png?v=1783694016',
    Tuxedo: '/assets/Blazer /Shapes/Tuxedo.png?v=1783693958',
  },
  length: {
    'Blazer dress (mini)': '/assets/Blazer /Length/Blazer dress (mini).png?v=1783698678',
    Cropped_: '/assets/Blazer /Length/Cropped_.png?v=1783698854',
    'Hip length_': '/assets/Blazer /Length/Hip length_.png?v=1783698748',
    'Long line_': '/assets/Blazer /Length/Long line_.png?v=1783698736',
    'Maxi length_': '/assets/Blazer /Length/Maxi length_.png?v=1783698636',
    'Tunic length_': '/assets/Blazer /Length/Tunic length_.png?v=1783698700',
    'Waist length_': '/assets/Blazer /Length/Waist length_.png?v=1783698822',
  },
  neckline: {
    Collarless_: '/assets/Blazer /Neckline & lapels /Collarless_.png?v=1783694328',
    'Draped collar': '/assets/Blazer /Neckline & lapels /Draped collar.png?v=1783694182',
    'Hooded blazer': '/assets/Blazer /Neckline & lapels /Hooded blazer.png?v=1783694164',
    'Mandarin collar': '/assets/Blazer /Neckline & lapels /Mandarin collar.png?v=1783694314',
    'Notched lapel_': '/assets/Blazer /Neckline & lapels /Notched lapel_.png?v=1783694418',
    'Off shoulder_': '/assets/Blazer /Neckline & lapels /Off shoulder_.png?v=1783694210',
    'One shoulder lapels_': '/assets/Blazer /Neckline & lapels /One shoulder lapels_.png?v=1783694198',
    'Peak lapel_': '/assets/Blazer /Neckline & lapels /Peak lapel_.png?v=1783694386',
    'Plunge neck_': '/assets/Blazer /Neckline & lapels /Plunge neck_.png?v=1783694222',
    'Scoop neck_': '/assets/Blazer /Neckline & lapels /Scoop neck_.png?v=1783694246',
    'Shawl lapel_': '/assets/Blazer /Neckline & lapels /Shawl lapel_.png?v=1783694372',
    'Square neck_': '/assets/Blazer /Neckline & lapels /Square neck_.png?v=1783694234',
    'Stand collar': '/assets/Blazer /Neckline & lapels /Stand collar.png?v=1783694290',
    'Tuxedo laple': '/assets/Blazer /Neckline & lapels /Tuxedo laple.png?v=1783694358',
    'V neck_': '/assets/Blazer /Neckline & lapels /V neck_.png?v=1783694258',
  },
  sleeve: {
    '3_4 length_': '/assets/Blazer /Sleeve /3_4 length_.png?v=1783700264',
    'Balloon sleeve_': '/assets/Blazer /Sleeve /Balloon sleeve_.png?v=1783700186',
    'Bell sleeve': '/assets/Blazer /Sleeve /Bell sleeve.png?v=1783700204',
    'Cape sleeve_': '/assets/Blazer /Sleeve /Cape sleeve_.png?v=1783700170',
    'Cut out sleeve_': '/assets/Blazer /Sleeve /Cut out sleeve_.png?v=1783700154',
    'Elbow length_': '/assets/Blazer /Sleeve /Elbow length_.png?v=1783700248',
    'Long sleeve_': '/assets/Blazer /Sleeve /Long sleeve_.png?v=1783700276',
    'Push-up sleeve_': '/assets/Blazer /Sleeve /Push-up sleeve_.png?v=1783700220',
    'Ruched sleeve_': '/assets/Blazer /Sleeve /Ruched sleeve_.png?v=1783700236',
    Sleeveless_: '/assets/Blazer /Sleeve /Sleeveless_.png?v=1783700140',
  },
};

export const WOMEN_HOODIES_ASSET_MAP = {
  style: {
    IMG_5256: '/assets/Hoodies /IMG_5256.png?v=1780992008',
    IMG_5257: '/assets/Hoodies /IMG_5257.png?v=1780992010',
    IMG_5258: '/assets/Hoodies /IMG_5258.png?v=1780992010',
    IMG_5259: '/assets/Hoodies /IMG_5259.png?v=1780992010',
    IMG_5260: '/assets/Hoodies /IMG_5260.png?v=1780992010',
    IMG_5261: '/assets/Hoodies /IMG_5261.png?v=1780992010',
    IMG_5262: '/assets/Hoodies /IMG_5262.png?v=1780992010',
  },
};

export const WOMEN_LAYERING_ASSET_MAP = {
  style: {
    'Belt wrap cardigan_': '/assets/Layering /Belt wrap cardigan_.png?v=1780991990',
    'Belted longline_(1)': '/assets/Layering /Belted longline_(1).png?v=1780991990',
    'Belted longline_': '/assets/Layering /Belted longline_.png?v=1780991990',
    'Cable knit cardigan_': '/assets/Layering /Cable knit cardigan_.png?v=1780991990',
    'Cape shrug_': '/assets/Layering /Cape shrug_.png?v=1780991990',
    'Colour block cardigan_': '/assets/Layering /Colour block cardigan_.png?v=1780991990',
    'Crochet shrug_': '/assets/Layering /Crochet shrug_.png?v=1780991990',
    'Furry shrug_': '/assets/Layering /Furry shrug_.png?v=1780991992',
    'Hodded longline_': '/assets/Layering /Hodded longline_.png?v=1780991992',
    IMG_5291: '/assets/Layering /IMG_5291.png?v=1780991992',
    IMG_5292: '/assets/Layering /IMG_5292.png?v=1780991992',
    IMG_5293: '/assets/Layering /IMG_5293.png?v=1780991992',
    IMG_5294: '/assets/Layering /IMG_5294.png?v=1780991992',
    IMG_5295: '/assets/Layering /IMG_5295.png?v=1780991992',
    IMG_5296: '/assets/Layering /IMG_5296.png?v=1780991992',
    'Knit Batwing shrug_': '/assets/Layering /Knit Batwing shrug_.png?v=1780991992',
    'Long line vest_': '/assets/Layering /Long line vest_.png?v=1780991992',
    'Longline ribbed cardigan_': '/assets/Layering /Longline ribbed cardigan_.png?v=1780991994',
    'Longline shacket': '/assets/Layering /Longline shacket.png?v=1780991994',
    'Open front cardigan_': '/assets/Layering /Open front cardigan_.png?v=1780991994',
    'Quilt shrug_': '/assets/Layering /Quilt shrug_.png?v=1780991994',
    'Ribbed shrug_': '/assets/Layering /Ribbed shrug_.png?v=1780991994',
    'V neck button cardigan_': '/assets/Layering /V neck button cardigan_.png?v=1780991994',
    'Water fall longline_': '/assets/Layering /Water fall longline_.png?v=1780991994',
  },
};

export const WOMEN_JACKET_ASSET_MAP = {
  style: {
    'Barn jacket_': '/assets/Jackets /style/Barn jacket_.png?v=1780991998',
    'Fleece jacket ': '/assets/Jackets /style/Fleece jacket .png?v=1781191834',
    'Puffer jacket_': '/assets/Jackets /style/Puffer jacket_.png?v=1780991998',
    'Soft shell jacket ': '/assets/Jackets /style/Soft shell jacket .png?v=1781191834',
    'Sport jacket_': '/assets/Jackets /style/Sport jacket_.png?v=1780991998',
    'Street wear jacket ': '/assets/Jackets /style/Street wear jacket .png?v=1781191834',
    'Wind breaker_': '/assets/Jackets /style/Wind breaker_.png?v=1780992000',
  },
  sleeve: {
    'Adjustable cuff sleeve_': '/assets/Jackets /Sleeves /Adjustable cuff sleeve_.png?v=1780992004',
    'Cuffed sleeve_': '/assets/Jackets /Sleeves /Cuffed sleeve_.png?v=1780992004',
    'Drop shoulder_': '/assets/Jackets /Sleeves /Drop shoulder_.png?v=1780992004',
    'Elbow patch_': '/assets/Jackets /Sleeves /Elbow patch_.png?v=1780992004',
    'Panelled sleeve_': '/assets/Jackets /Sleeves /Panelled sleeve_.png?v=1780992004',
    'Princess sleeve_': '/assets/Jackets /Sleeves /Princess sleeve_.png?v=1780992004',
    'Quilt sleeve_': '/assets/Jackets /Sleeves /Quilt sleeve_.png?v=1780992006',
    'Raglan sleeve_': '/assets/Jackets /Sleeves /Raglan sleeve_.png?v=1780992006',
    'Set in sleeve_': '/assets/Jackets /Sleeves /Set in sleeve_.png?v=1780992006',
    'Two piece sleeve_': '/assets/Jackets /Sleeves /Two piece sleeve_.png?v=1780992006',
  },
  neckline: {
    'Asymmetrical stand collar_': '/assets/Jackets /Neck line /Asymmetrical stand collar_.png?v=1780992000',
    'Attaches hood_': '/assets/Jackets /Neck line /Attaches hood_.png?v=1780992000',
    'Corduroy collar ': '/assets/Jackets /Neck line /Corduroy collar .png?v=1780992000',
    'Detachable hood_': '/assets/Jackets /Neck line /Detachable hood_.png?v=1780992000',
    'Detached collar_': '/assets/Jackets /Neck line /Detached collar_.png?v=1780992000',
    'Funnel neck_': '/assets/Jackets /Neck line /Funnel neck_.png?v=1780992000',
    'High neck_': '/assets/Jackets /Neck line /High neck_.png?v=1780992000',
    'Hood with high neck_': '/assets/Jackets /Neck line /Hood with high neck_.png?v=1780992000',
    'Ribbedstand collar_': '/assets/Jackets /Neck line /Ribbedstand collar_.png?v=1780992000',
    'Sharper collar_': '/assets/Jackets /Neck line /Sharper collar_.png?v=1780992002',
    'Shawl collar_': '/assets/Jackets /Neck line /Shawl collar_.png?v=1780992002',
    'Shirt collar_': '/assets/Jackets /Neck line /Shirt collar_.png?v=1780992002',
    'Spread collar_': '/assets/Jackets /Neck line /Spread collar_.png?v=1780992002',
    'Stand collar with snap_': '/assets/Jackets /Neck line /Stand collar with snap_.png?v=1780992002',
    'Stand in collar_': '/assets/Jackets /Neck line /Stand in collar_.png?v=1780992002',
  },
};

export const WOMEN_PANT_ASSET_MAP = {
  silhouette: {
    'Barrel leg_': '/assets/Women pants /Silhouette and shape /Pants /Barrel leg_.png?v=1780991448',
    'Boot cut_': '/assets/Women pants /Silhouette and shape /Pants /Boot cut_.png?v=1780991450',
    'Pleated trouser_': '/assets/Women pants /Silhouette and shape /Pants /Pleated trouser_.png?v=1780991450',
    'Skinny fit_': '/assets/Women pants /Silhouette and shape /Pants /Skinny fit_.png?v=1780991450',
    'Slim fit_': '/assets/Women pants /Silhouette and shape /Pants /Slim fit_.png?v=1780991450',
    'Straight fit_': '/assets/Women pants /Silhouette and shape /Pants /Straight fit_.png?v=1780991450',
    'Wide leg trousers_': '/assets/Women pants /Silhouette and shape /Pants /Wide leg trousers_.png?v=1780991450',
    'Wide leg_': '/assets/Women pants /Silhouette and shape /Pants /Wide leg_.png?v=1780991450',
  },
  length: {
    'Above ankle_': '/assets/Women pants /Length /Jeans/Above ankle_.png?v=1780991462',
    'Extra long_': '/assets/Women pants /Length /Jeans/Extra long_.png?v=1780991462',
    'Full length_': '/assets/Women pants /Length /Jeans/Full length_.png?v=1780991462',
    'Mid calf_': '/assets/Women pants /Length /Jeans/Mid calf_.png?v=1780991462',
  },
  rise: {
    'High rise_': '/assets/Women pants /Rise /High rise_.png?v=1780991454',
    'Low rise_': '/assets/Women pants /Rise /Low rise_.png?v=1780991454',
    'Mid rise_': '/assets/Women pants /Rise /Mid rise_.png?v=1780991454',
  },
  waist: {
    'Contour waistband_': '/assets/Women pants /Waist construction /Contour waistband_.png?v=1780991452',
    'Drawstring waist_': '/assets/Women pants /Waist construction /Drawstring waist_.png?v=1780991452',
    'Elastic waist band': '/assets/Women pants /Waist construction /Elastic waist band.png?v=1780991452',
    'Extender tab with button_': '/assets/Women pants /Waist construction /Extender tab with button_.png?v=1780991452',
    'Paper bag_': '/assets/Women pants /Waist construction /Paper bag_.png?v=1780991454',
    'Partially elastic waistband_': '/assets/Women pants /Waist construction /Partially elastic waistband_.png?v=1780991454',
    'Side adjuster_': '/assets/Women pants /Waist construction /Side adjuster_.png?v=1780991454',
    'Straight waist band_': '/assets/Women pants /Waist construction /Straight waist band_.png?v=1780991454',
  },
  opening: {
    'Button and zip fly_': '/assets/Women pants /Opening - clouser/Jeans /Button and zip fly_.png?v=1780991458',
    'Button fly_': '/assets/Women pants /Opening - clouser/Jeans /Button fly_.png?v=1780991458',
    'Drawstring waist_': '/assets/Women pants /Opening - clouser/Jeans /Drawstring waist_.png?v=1780991460',
    'Elastic waist_': '/assets/Women pants /Opening - clouser/Jeans /Elastic waist_.png?v=1780991460',
    'Hook and bar_': '/assets/Women pants /Opening - clouser/Jeans /Hook and bar_.png?v=1780991460',
  },
  pocket: {
    'Elastic waist with patch pocket_': '/assets/Women pants /Pants pocket /Elastic waist with patch pocket_.png?v=1780991454',
    'Flap pocket_': '/assets/Women pants /Pants pocket /Flap pocket_.png?v=1780991456',
    'One welt pocket & one patch_': '/assets/Women pants /Pants pocket /One welt pocket & one patch_.png?v=1780991456',
    'Patch pocket_': '/assets/Women pants /Pants pocket /Patch pocket_.png?v=1780991456',
    'Side adjuster tabs with welt pocket_': '/assets/Women pants /Pants pocket /Side adjuster tabs with welt pocket_.png?v=1780991456',
    'Welt pocket with button_': '/assets/Women pants /Pants pocket /Welt pocket with button_.png?v=1780991456',
    'Welt pocket_': '/assets/Women pants /Pants pocket /Welt pocket_.png?v=1780991456',
  },
  yoke: {
    'Curved yoke_': '/assets/Women pants /Yoke/Curved yoke_.png?v=1780991462',
    'No yoke_': '/assets/Women pants /Yoke/No yoke_.png?v=1780991462',
    'V shape yoke_': '/assets/Women pants /Yoke/V shape yoke_.png?v=1780991462',
  },
};

export const WOMEN_SKIRT_ASSET_MAP = {
  shape: {
    'A line_': '/assets/skirt /Shape variation /A line_.png?v=1780990924',
    'Mimi A line_': '/assets/skirt /Shape variation /Mimi A line_.png?v=1780990924',
    Pencil_: '/assets/skirt /Shape variation /Pencil_.png?v=1780990924',
    'Slim fit_': '/assets/skirt /Shape variation /Slim fit_.png?v=1780990926',
    Straight_: '/assets/skirt /Shape variation /Straight_.png?v=1780990926',
    Tulip_: '/assets/skirt /Shape variation /Tulip_.png?v=1780990926',
    Wrap_: '/assets/skirt /Shape variation /Wrap_.png?v=1780990926',
  },
  length: {
    'Knee length_': '/assets/skirt /Length /Knee length_.png?v=1780990928',
    'Maxi (ankle length )_': '/assets/skirt /Length /Maxi (ankle length )_.png?v=1780990928',
    'Micro mini_': '/assets/skirt /Length /Micro mini_.png?v=1780990928',
    'Mid calf_': '/assets/skirt /Length /Mid calf_.png?v=1780990928',
    Mini_: '/assets/skirt /Length /Mini_.png?v=1780990928',
  },
  flair: {
    '180 ( semi circle)_': '/assets/skirt /Flair variation /180 ( semi circle)_.png?v=1780990920',
    'Accordion pleated_': '/assets/skirt /Flair variation /Accordion pleated_.png?v=1780990920',
    'Box pleated_': '/assets/skirt /Flair variation /Box pleated_.png?v=1780990922',
    Circle: '/assets/skirt /Flair variation /Circle.png?v=1780990922',
    Flared_: '/assets/skirt /Flair variation /Flared_.png?v=1780990922',
    'Four flair_': '/assets/skirt /Flair variation /Four flair_.png?v=1780990922',
    Gathered_: '/assets/skirt /Flair variation /Gathered_.png?v=1780990922',
    Godet_: '/assets/skirt /Flair variation /Godet_.png?v=1780990922',
    'Handkerchief Hem flair_': '/assets/skirt /Flair variation /Handkerchief Hem flair_.png?v=1780990922',
    'Knife pleated_': '/assets/skirt /Flair variation /Knife pleated_.png?v=1780990922',
    'Low gathered_': '/assets/skirt /Flair variation /Low gathered_.png?v=1780990924',
    Mermaid_: '/assets/skirt /Flair variation /Mermaid_.png?v=1780990924',
    Pleated_: '/assets/skirt /Flair variation /Pleated_.png?v=1780990924',
    'Sunray pleated': '/assets/skirt /Flair variation /Sunray pleated.png?v=1780990924',
    Tiered: '/assets/skirt /Flair variation /Tiered.png?v=1780990924',
  },
  waist: {
    'Asymmetric waistband_': '/assets/skirt /Waist variation (belt) /Asymmetric waistband_.png?v=1780990926',
    'Belted waist_': '/assets/skirt /Waist variation (belt) /Belted waist_.png?v=1780990926',
    'Curved waistband_': '/assets/skirt /Waist variation (belt) /Curved waistband_.png?v=1780990926',
    'Paper bag waist band_': '/assets/skirt /Waist variation (belt) /Paper bag waist band_.png?v=1780990926',
    'Straight waistband_': '/assets/skirt /Waist variation (belt) /Straight waistband_.png?v=1780990926',
    'V shaped waistband': '/assets/skirt /Waist variation (belt) /V shaped waistband.png?v=1780990928',
    'Wide waistband_': '/assets/skirt /Waist variation (belt) /Wide waistband_.png?v=1780990928',
  },
};

export const WOMEN_SHIRT_ASSET_MAP = {
  neckline: {
    'Band collar': '/assets/women shirt /Neck line /Band collar.png?v=1783266506',
    'Classic collar_': '/assets/women shirt /Neck line /Classic collar_.png?v=1783266564',
    'Frill neck_': '/assets/women shirt /Neck line /Frill neck_.png?v=1783266374',
    'Halter neck_': '/assets/women shirt /Neck line /Halter neck_.png?v=1783266488',
    'Mandarin collar_': '/assets/women shirt /Neck line /Mandarin collar_.png?v=1783266530',
    'Off shoulder_': '/assets/women shirt /Neck line /Off shoulder_.png?v=1783266446',
    'One shoulder_': '/assets/women shirt /Neck line /One shoulder_.png?v=1783266466',
    'Plunge neckline_': '/assets/women shirt /Neck line /Plunge neckline_.png?v=1783266356',
    'Ruffle neck line_': '/assets/women shirt /Neck line /Ruffle neck line_.png?v=1783266396',
    'Spread collar_': '/assets/women shirt /Neck line /Spread collar_.png?v=1783266550',
    'Tie neck_': '/assets/women shirt /Neck line /Tie neck_.png?v=1783266416',
  },
  fit: {
    'A line_': '/assets/women shirt /Fit/A line_.png?v=1783266964',
    Fitted_: '/assets/women shirt /Fit/Fitted_.png?v=1783267056',
    'High low hem_': '/assets/women shirt /Fit/High low hem_.png?v=1783266950',
    Oversized_: '/assets/women shirt /Fit/Oversized_.png?v=1783266990',
    'Relaxed fit_': '/assets/women shirt /Fit/Relaxed fit_.png?v=1783267016',
    'Slim fit_': '/assets/women shirt /Fit/Slim fit_.png?v=1783267066',
  },
  hem: {
    'Add a heading - 492': '/assets/women shirt /Hem/Add a heading - 492.png?v=1783268682',
    'Asymmetric hem_': '/assets/women shirt /Hem/Asymmetric hem_.png?v=1783268974',
    'Drawstring hem_': '/assets/women shirt /Hem/Drawstring hem_.png?v=1783268890',
    'Elastic hem_': '/assets/women shirt /Hem/Elastic hem_.png?v=1783268906',
    'High front low back hem_': '/assets/women shirt /Hem/High front low back hem_.png?v=1783268938',
    'Round hem_': '/assets/women shirt /Hem/Round hem_.png?v=1783268998',
    'Shirt tail hem_': '/assets/women shirt /Hem/Shirt tail hem_.png?v=1783269032',
    'Side slit hem_': '/assets/women shirt /Hem/Side slit hem_.png?v=1783268956',
    'Straight hem': '/assets/women shirt /Hem/Straight hem.png?v=1783269054',
  },
  drape: {
    'Cascading drape_': '/assets/women shirt /Drape /Cascading drape_.png?v=1783266658',
    'Empire waist_': '/assets/women shirt /Drape /Empire waist_.png?v=1783266888',
    'Gathered drape_': '/assets/women shirt /Drape /Gathered drape_.png?v=1783266676',
    'Heavy drape_': '/assets/women shirt /Drape /Heavy drape_.png?v=1783266636',
    'High low_': '/assets/women shirt /Drape /High low_.png?v=1783266768',
    Peplum_: '/assets/women shirt /Drape /Peplum_.png?v=1783266902',
    'Pleated drape_': '/assets/women shirt /Drape /Pleated drape_.png?v=1783266732',
    'Shirt dress_': '/assets/women shirt /Drape /Shirt dress_.png?v=1783266754',
    'Tie drape_': '/assets/women shirt /Drape /Tie drape_.png?v=1783266692',
    'Twist drape_': '/assets/women shirt /Drape /Twist drape_.png?v=1783266706',
    'Wrap around_': '/assets/women shirt /Drape /Wrap around_.png?v=1783266858',
  },
};

export const SOCKS_ASSET_MAP = {
  length: {
    Ankle: '/assets/socks/LENGTH/Ankle.png?v=1784652145',
    Crew: '/assets/socks/LENGTH/Crew.png?v=1784652145',
    'Knee-High': '/assets/socks/LENGTH/Knee-High.png?v=1784652145',
    'Mid-Calf': '/assets/socks/LENGTH/Mid-Calf.png?v=1784652145',
    'No-Show': '/assets/socks/LENGTH/No-Show.png?v=1784652140',
    'Over-the-Knee': '/assets/socks/LENGTH/Over-the-Knee.png?v=1784652145',
    Quarter: '/assets/socks/LENGTH/Quarter.png?v=1784652145',
    'Thigh-High': '/assets/socks/LENGTH/Thigh-High.png?v=1784652145',
  },
  cuffStyle: {
    'Frill - Ruffle cuff': '/assets/socks/cuffs/Frill - Ruffle cuff.png?v=1784652420',
    'Lace trim cuff': '/assets/socks/cuffs/Lace trim cuff.png?v=1784652420',
    'No cuff (raw edge)': '/assets/socks/cuffs/No cuff (raw edge).png?v=1784652419',
    'Ribbed cuff': '/assets/socks/cuffs/Ribbed cuff.png?v=1784652419',
    'Rolled cuff': '/assets/socks/cuffs/Rolled cuff.png?v=1784652421',
    'Scalloped edge': '/assets/socks/cuffs/Scalloped edge.png?v=1784652421',
    'Turn-down cuff': '/assets/socks/cuffs/Turn-down cuff.png?v=1784652419',
  },
  toeStyle: {
    'Closed toe': '/assets/socks/toe style/Closed toe.png?v=1784652852',
    'Open toe (toeless)': '/assets/socks/toe style/Open toe (toeless).png?v=1784652854',
    'Reinforced toe': '/assets/socks/toe style/Reinforced toe.png?v=1784652856',
    'Split toe (tabi)': '/assets/socks/toe style/Split toe (tabi).png?v=1784652855',
  },
};
